// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.0
//   protoc               v4.25.3
// source: messenger/trajectory_controller_service.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { FileDescriptorProto as FileDescriptorProto1 } from "ts-proto-descriptors";
import { Empty, protoMetadata as protoMetadata1 } from "../google/protobuf/empty";
import { protoMetadata as protoMetadata2, Timestamp } from "../google/protobuf/timestamp";
import { Pose, protoMetadata as protoMetadata3, Quaternion, Vector3 } from "./geometry";
import { JointTrajectory, protoMetadata as protoMetadata4 } from "./joints";

export const protobufPackage = "trajectorycontroller";

export enum TCState {
  TC_IDLE = 0,
  TC_EXECUTING = 1,
  TC_STOPPING = 2,
  TC_ERROR = 3,
  UNRECOGNIZED = -1,
}

export function tCStateFromJSON(object: any): TCState {
  switch (object) {
    case 0:
    case "TC_IDLE":
      return TCState.TC_IDLE;
    case 1:
    case "TC_EXECUTING":
      return TCState.TC_EXECUTING;
    case 2:
    case "TC_STOPPING":
      return TCState.TC_STOPPING;
    case 3:
    case "TC_ERROR":
      return TCState.TC_ERROR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TCState.UNRECOGNIZED;
  }
}

export function tCStateToJSON(object: TCState): string {
  switch (object) {
    case TCState.TC_IDLE:
      return "TC_IDLE";
    case TCState.TC_EXECUTING:
      return "TC_EXECUTING";
    case TCState.TC_STOPPING:
      return "TC_STOPPING";
    case TCState.TC_ERROR:
      return "TC_ERROR";
    case TCState.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum TCErrorCode {
  TC_ERROR_NONE = 0,
  TC_ERROR_IN_SINGULARITY = 1,
  TC_ERROR_TRAJECTORY_OVER_LIMITS = 2,
  TC_ERROR_JOINT_COMMAND_OUT_OF_LIMITS = 3,
  TC_ERROR_STALENESS_TIMEOUT = 4,
  TC_ERROR_INVALID_TRAJECTORY = 5,
  TC_ERROR_COMPUTATION = 6,
  TC_ERROR_WORKSPACE_LIMIT_VIOLATION = 7,
  TC_ERROR_OVERRUN = 8,
  TC_ERROR_QUEUE_FULL = 9,
  TC_ERROR_NO_CONTROL = 10,
  TC_ERROR_NOT_READY = 11,
  /** TC_ERROR_NOT_IDLE - setter rejected because TC not IDLE */
  TC_ERROR_NOT_IDLE = 12,
  /** TC_ERROR_INVALID_ARGUMENT - out-of-range / wrong length / NaN */
  TC_ERROR_INVALID_ARGUMENT = 13,
  /** TC_ERROR_FRAME_NOT_SPECIFIED - SpeedL frame-slot validation (commanded_frame / reference / velocity_expressed_in). */
  TC_ERROR_FRAME_NOT_SPECIFIED = 14,
  /**
   * TC_ERROR_FRAME_NOT_SUPPORTED - Parent frame not supported (e.g. CAMERA commanded_frame, FLANGE velocity
   * axes).
   */
  TC_ERROR_FRAME_NOT_SUPPORTED = 15,
  /** TC_ERROR_INCOMPATIBLE_FRAMES - Reference and commanded_frame on the same side (not actuatable). */
  TC_ERROR_INCOMPATIBLE_FRAMES = 16,
  /**
   * TC_ERROR_MALFORMED_TARGET - Streamed target structurally malformed (missing field, wrong arity); ends
   * the streaming session.
   */
  TC_ERROR_MALFORMED_TARGET = 17,
  /** TC_ERROR_STREAM_JUMP - ServoL: consecutive streamed poses too far apart */
  TC_ERROR_STREAM_JUMP = 18,
  /** TC_ERROR_TRACKER_ERROR_EXCEEDED - ServoL: target too far from the tracked pose */
  TC_ERROR_TRACKER_ERROR_EXCEEDED = 19,
  /** TC_ERROR_SELF_COLLISION - self-collision detected */
  TC_ERROR_SELF_COLLISION = 20,
  /** TC_ERROR_INVALID_COLLISION_CONFIG - invalid collision configuration */
  TC_ERROR_INVALID_COLLISION_CONFIG = 21,
  UNRECOGNIZED = -1,
}

export function tCErrorCodeFromJSON(object: any): TCErrorCode {
  switch (object) {
    case 0:
    case "TC_ERROR_NONE":
      return TCErrorCode.TC_ERROR_NONE;
    case 1:
    case "TC_ERROR_IN_SINGULARITY":
      return TCErrorCode.TC_ERROR_IN_SINGULARITY;
    case 2:
    case "TC_ERROR_TRAJECTORY_OVER_LIMITS":
      return TCErrorCode.TC_ERROR_TRAJECTORY_OVER_LIMITS;
    case 3:
    case "TC_ERROR_JOINT_COMMAND_OUT_OF_LIMITS":
      return TCErrorCode.TC_ERROR_JOINT_COMMAND_OUT_OF_LIMITS;
    case 4:
    case "TC_ERROR_STALENESS_TIMEOUT":
      return TCErrorCode.TC_ERROR_STALENESS_TIMEOUT;
    case 5:
    case "TC_ERROR_INVALID_TRAJECTORY":
      return TCErrorCode.TC_ERROR_INVALID_TRAJECTORY;
    case 6:
    case "TC_ERROR_COMPUTATION":
      return TCErrorCode.TC_ERROR_COMPUTATION;
    case 7:
    case "TC_ERROR_WORKSPACE_LIMIT_VIOLATION":
      return TCErrorCode.TC_ERROR_WORKSPACE_LIMIT_VIOLATION;
    case 8:
    case "TC_ERROR_OVERRUN":
      return TCErrorCode.TC_ERROR_OVERRUN;
    case 9:
    case "TC_ERROR_QUEUE_FULL":
      return TCErrorCode.TC_ERROR_QUEUE_FULL;
    case 10:
    case "TC_ERROR_NO_CONTROL":
      return TCErrorCode.TC_ERROR_NO_CONTROL;
    case 11:
    case "TC_ERROR_NOT_READY":
      return TCErrorCode.TC_ERROR_NOT_READY;
    case 12:
    case "TC_ERROR_NOT_IDLE":
      return TCErrorCode.TC_ERROR_NOT_IDLE;
    case 13:
    case "TC_ERROR_INVALID_ARGUMENT":
      return TCErrorCode.TC_ERROR_INVALID_ARGUMENT;
    case 14:
    case "TC_ERROR_FRAME_NOT_SPECIFIED":
      return TCErrorCode.TC_ERROR_FRAME_NOT_SPECIFIED;
    case 15:
    case "TC_ERROR_FRAME_NOT_SUPPORTED":
      return TCErrorCode.TC_ERROR_FRAME_NOT_SUPPORTED;
    case 16:
    case "TC_ERROR_INCOMPATIBLE_FRAMES":
      return TCErrorCode.TC_ERROR_INCOMPATIBLE_FRAMES;
    case 17:
    case "TC_ERROR_MALFORMED_TARGET":
      return TCErrorCode.TC_ERROR_MALFORMED_TARGET;
    case 18:
    case "TC_ERROR_STREAM_JUMP":
      return TCErrorCode.TC_ERROR_STREAM_JUMP;
    case 19:
    case "TC_ERROR_TRACKER_ERROR_EXCEEDED":
      return TCErrorCode.TC_ERROR_TRACKER_ERROR_EXCEEDED;
    case 20:
    case "TC_ERROR_SELF_COLLISION":
      return TCErrorCode.TC_ERROR_SELF_COLLISION;
    case 21:
    case "TC_ERROR_INVALID_COLLISION_CONFIG":
      return TCErrorCode.TC_ERROR_INVALID_COLLISION_CONFIG;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TCErrorCode.UNRECOGNIZED;
  }
}

export function tCErrorCodeToJSON(object: TCErrorCode): string {
  switch (object) {
    case TCErrorCode.TC_ERROR_NONE:
      return "TC_ERROR_NONE";
    case TCErrorCode.TC_ERROR_IN_SINGULARITY:
      return "TC_ERROR_IN_SINGULARITY";
    case TCErrorCode.TC_ERROR_TRAJECTORY_OVER_LIMITS:
      return "TC_ERROR_TRAJECTORY_OVER_LIMITS";
    case TCErrorCode.TC_ERROR_JOINT_COMMAND_OUT_OF_LIMITS:
      return "TC_ERROR_JOINT_COMMAND_OUT_OF_LIMITS";
    case TCErrorCode.TC_ERROR_STALENESS_TIMEOUT:
      return "TC_ERROR_STALENESS_TIMEOUT";
    case TCErrorCode.TC_ERROR_INVALID_TRAJECTORY:
      return "TC_ERROR_INVALID_TRAJECTORY";
    case TCErrorCode.TC_ERROR_COMPUTATION:
      return "TC_ERROR_COMPUTATION";
    case TCErrorCode.TC_ERROR_WORKSPACE_LIMIT_VIOLATION:
      return "TC_ERROR_WORKSPACE_LIMIT_VIOLATION";
    case TCErrorCode.TC_ERROR_OVERRUN:
      return "TC_ERROR_OVERRUN";
    case TCErrorCode.TC_ERROR_QUEUE_FULL:
      return "TC_ERROR_QUEUE_FULL";
    case TCErrorCode.TC_ERROR_NO_CONTROL:
      return "TC_ERROR_NO_CONTROL";
    case TCErrorCode.TC_ERROR_NOT_READY:
      return "TC_ERROR_NOT_READY";
    case TCErrorCode.TC_ERROR_NOT_IDLE:
      return "TC_ERROR_NOT_IDLE";
    case TCErrorCode.TC_ERROR_INVALID_ARGUMENT:
      return "TC_ERROR_INVALID_ARGUMENT";
    case TCErrorCode.TC_ERROR_FRAME_NOT_SPECIFIED:
      return "TC_ERROR_FRAME_NOT_SPECIFIED";
    case TCErrorCode.TC_ERROR_FRAME_NOT_SUPPORTED:
      return "TC_ERROR_FRAME_NOT_SUPPORTED";
    case TCErrorCode.TC_ERROR_INCOMPATIBLE_FRAMES:
      return "TC_ERROR_INCOMPATIBLE_FRAMES";
    case TCErrorCode.TC_ERROR_MALFORMED_TARGET:
      return "TC_ERROR_MALFORMED_TARGET";
    case TCErrorCode.TC_ERROR_STREAM_JUMP:
      return "TC_ERROR_STREAM_JUMP";
    case TCErrorCode.TC_ERROR_TRACKER_ERROR_EXCEEDED:
      return "TC_ERROR_TRACKER_ERROR_EXCEEDED";
    case TCErrorCode.TC_ERROR_SELF_COLLISION:
      return "TC_ERROR_SELF_COLLISION";
    case TCErrorCode.TC_ERROR_INVALID_COLLISION_CONFIG:
      return "TC_ERROR_INVALID_COLLISION_CONFIG";
    case TCErrorCode.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum PrimitiveEventType {
  PRIMITIVE_EVENT_UNSPECIFIED = 0,
  /** PRIMITIVE_STARTED - Primitive began executing. */
  PRIMITIVE_STARTED = 1,
  /** PRIMITIVE_COMPLETE - Primitive finished naturally (isComplete() returned true). */
  PRIMITIVE_COMPLETE = 2,
  /** PRIMITIVE_STOPPED - Primitive was interrupted by Stop/FastStop before completing. */
  PRIMITIVE_STOPPED = 3,
  /** PRIMITIVE_FAILED - Primitive encountered an error (see error field). */
  PRIMITIVE_FAILED = 4,
  /** PRIMITIVE_QUEUE_CLEARED - ClearQueue was called; pending primitives were discarded. */
  PRIMITIVE_QUEUE_CLEARED = 5,
  UNRECOGNIZED = -1,
}

export function primitiveEventTypeFromJSON(object: any): PrimitiveEventType {
  switch (object) {
    case 0:
    case "PRIMITIVE_EVENT_UNSPECIFIED":
      return PrimitiveEventType.PRIMITIVE_EVENT_UNSPECIFIED;
    case 1:
    case "PRIMITIVE_STARTED":
      return PrimitiveEventType.PRIMITIVE_STARTED;
    case 2:
    case "PRIMITIVE_COMPLETE":
      return PrimitiveEventType.PRIMITIVE_COMPLETE;
    case 3:
    case "PRIMITIVE_STOPPED":
      return PrimitiveEventType.PRIMITIVE_STOPPED;
    case 4:
    case "PRIMITIVE_FAILED":
      return PrimitiveEventType.PRIMITIVE_FAILED;
    case 5:
    case "PRIMITIVE_QUEUE_CLEARED":
      return PrimitiveEventType.PRIMITIVE_QUEUE_CLEARED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PrimitiveEventType.UNRECOGNIZED;
  }
}

export function primitiveEventTypeToJSON(object: PrimitiveEventType): string {
  switch (object) {
    case PrimitiveEventType.PRIMITIVE_EVENT_UNSPECIFIED:
      return "PRIMITIVE_EVENT_UNSPECIFIED";
    case PrimitiveEventType.PRIMITIVE_STARTED:
      return "PRIMITIVE_STARTED";
    case PrimitiveEventType.PRIMITIVE_COMPLETE:
      return "PRIMITIVE_COMPLETE";
    case PrimitiveEventType.PRIMITIVE_STOPPED:
      return "PRIMITIVE_STOPPED";
    case PrimitiveEventType.PRIMITIVE_FAILED:
      return "PRIMITIVE_FAILED";
    case PrimitiveEventType.PRIMITIVE_QUEUE_CLEARED:
      return "PRIMITIVE_QUEUE_CLEARED";
    case PrimitiveEventType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum BuiltInFrame {
  BUILT_IN_FRAME_UNSPECIFIED = 0,
  BUILT_IN_FRAME_WORLD = 1,
  BUILT_IN_FRAME_BASE = 2,
  BUILT_IN_FRAME_FLANGE = 3,
  BUILT_IN_FRAME_CAMERA = 4,
  UNRECOGNIZED = -1,
}

export function builtInFrameFromJSON(object: any): BuiltInFrame {
  switch (object) {
    case 0:
    case "BUILT_IN_FRAME_UNSPECIFIED":
      return BuiltInFrame.BUILT_IN_FRAME_UNSPECIFIED;
    case 1:
    case "BUILT_IN_FRAME_WORLD":
      return BuiltInFrame.BUILT_IN_FRAME_WORLD;
    case 2:
    case "BUILT_IN_FRAME_BASE":
      return BuiltInFrame.BUILT_IN_FRAME_BASE;
    case 3:
    case "BUILT_IN_FRAME_FLANGE":
      return BuiltInFrame.BUILT_IN_FRAME_FLANGE;
    case 4:
    case "BUILT_IN_FRAME_CAMERA":
      return BuiltInFrame.BUILT_IN_FRAME_CAMERA;
    case -1:
    case "UNRECOGNIZED":
    default:
      return BuiltInFrame.UNRECOGNIZED;
  }
}

export function builtInFrameToJSON(object: BuiltInFrame): string {
  switch (object) {
    case BuiltInFrame.BUILT_IN_FRAME_UNSPECIFIED:
      return "BUILT_IN_FRAME_UNSPECIFIED";
    case BuiltInFrame.BUILT_IN_FRAME_WORLD:
      return "BUILT_IN_FRAME_WORLD";
    case BuiltInFrame.BUILT_IN_FRAME_BASE:
      return "BUILT_IN_FRAME_BASE";
    case BuiltInFrame.BUILT_IN_FRAME_FLANGE:
      return "BUILT_IN_FRAME_FLANGE";
    case BuiltInFrame.BUILT_IN_FRAME_CAMERA:
      return "BUILT_IN_FRAME_CAMERA";
    case BuiltInFrame.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * Severity of a TC notification.
 *
 * There is deliberately no ERROR value. Errors never traverse this path:
 * enterError() pushes the structured error straight into the debug event
 * mailbox, and Notification's constructor asserts the severity is not ERROR.
 * Offering an ERROR value here would invite a second, competing error channel.
 */
export enum TCSeverity {
  TC_SEVERITY_UNSPECIFIED = 0,
  TC_SEVERITY_INFO = 1,
  TC_SEVERITY_WARN = 2,
  UNRECOGNIZED = -1,
}

export function tCSeverityFromJSON(object: any): TCSeverity {
  switch (object) {
    case 0:
    case "TC_SEVERITY_UNSPECIFIED":
      return TCSeverity.TC_SEVERITY_UNSPECIFIED;
    case 1:
    case "TC_SEVERITY_INFO":
      return TCSeverity.TC_SEVERITY_INFO;
    case 2:
    case "TC_SEVERITY_WARN":
      return TCSeverity.TC_SEVERITY_WARN;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TCSeverity.UNRECOGNIZED;
  }
}

export function tCSeverityToJSON(object: TCSeverity): string {
  switch (object) {
    case TCSeverity.TC_SEVERITY_UNSPECIFIED:
      return "TC_SEVERITY_UNSPECIFIED";
    case TCSeverity.TC_SEVERITY_INFO:
      return "TC_SEVERITY_INFO";
    case TCSeverity.TC_SEVERITY_WARN:
      return "TC_SEVERITY_WARN";
    case TCSeverity.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * Mirrors bots::trajectory_controller::EventCode, one enumerator per condition
 * class (cpp/apps/arm-control-bot/src/trajectory_controller/events/Event.h).
 *
 * Append-only, never renumbered: this is a customer-facing vocabulary once it
 * leaves the robot. The C++ enum pins explicit values for the same reason, and
 * the C++ -> proto mapping is an exhaustive switch rather than a cast, so
 * reordering either side cannot silently rewrite a code's meaning.
 */
export enum TCEventCode {
  TC_EVENT_CODE_UNSPECIFIED = 0,
  TC_EVENT_CODE_INVALID_VELOCITY_CONSTRAINT = 1,
  TC_EVENT_CODE_MALFORMED_CONSTRAINT_LIST = 2,
  TC_EVENT_CODE_INVALID_NOMINAL = 3,
  TC_EVENT_CODE_BINDING_CONSTRAINT_CHANGED = 4,
  TC_EVENT_CODE_DIVIDE_BY_ZERO = 5,
  TC_EVENT_CODE_NON_FINITE_INPUT = 6,
  TC_EVENT_CODE_NON_FINITE_OUTPUT = 7,
  TC_EVENT_CODE_COMMAND_TIMEOUT = 8,
  TC_EVENT_CODE_NON_POSITIVE_LIMIT = 9,
  TC_EVENT_CODE_DECEL_HORIZON_OVERFLOW = 10,
  TC_EVENT_CODE_IK_SINGULAR = 11,
  TC_EVENT_CODE_IK_NO_SOLUTION = 12,
  TC_EVENT_CODE_IK_WARNING = 13,
  TC_EVENT_CODE_NON_UNIT_QUATERNION = 14,
  TC_EVENT_CODE_INVALID_FILTER_GAIN = 15,
  TC_EVENT_CODE_ACCEL_LIMIT_EXCEEDED = 16,
  TC_EVENT_CODE_FK_FAILED = 17,
  TC_EVENT_CODE_JACOBIAN_INVALID = 18,
  TC_EVENT_CODE_JACOBIAN_SINGULAR = 19,
  TC_EVENT_CODE_POSE_JUMP_EXCEEDED = 20,
  TC_EVENT_CODE_TRACKER_ERROR_EXCEEDED = 21,
  TC_EVENT_CODE_TRACKER_GAIN_EXCEEDS_ACCEL = 22,
  UNRECOGNIZED = -1,
}

export function tCEventCodeFromJSON(object: any): TCEventCode {
  switch (object) {
    case 0:
    case "TC_EVENT_CODE_UNSPECIFIED":
      return TCEventCode.TC_EVENT_CODE_UNSPECIFIED;
    case 1:
    case "TC_EVENT_CODE_INVALID_VELOCITY_CONSTRAINT":
      return TCEventCode.TC_EVENT_CODE_INVALID_VELOCITY_CONSTRAINT;
    case 2:
    case "TC_EVENT_CODE_MALFORMED_CONSTRAINT_LIST":
      return TCEventCode.TC_EVENT_CODE_MALFORMED_CONSTRAINT_LIST;
    case 3:
    case "TC_EVENT_CODE_INVALID_NOMINAL":
      return TCEventCode.TC_EVENT_CODE_INVALID_NOMINAL;
    case 4:
    case "TC_EVENT_CODE_BINDING_CONSTRAINT_CHANGED":
      return TCEventCode.TC_EVENT_CODE_BINDING_CONSTRAINT_CHANGED;
    case 5:
    case "TC_EVENT_CODE_DIVIDE_BY_ZERO":
      return TCEventCode.TC_EVENT_CODE_DIVIDE_BY_ZERO;
    case 6:
    case "TC_EVENT_CODE_NON_FINITE_INPUT":
      return TCEventCode.TC_EVENT_CODE_NON_FINITE_INPUT;
    case 7:
    case "TC_EVENT_CODE_NON_FINITE_OUTPUT":
      return TCEventCode.TC_EVENT_CODE_NON_FINITE_OUTPUT;
    case 8:
    case "TC_EVENT_CODE_COMMAND_TIMEOUT":
      return TCEventCode.TC_EVENT_CODE_COMMAND_TIMEOUT;
    case 9:
    case "TC_EVENT_CODE_NON_POSITIVE_LIMIT":
      return TCEventCode.TC_EVENT_CODE_NON_POSITIVE_LIMIT;
    case 10:
    case "TC_EVENT_CODE_DECEL_HORIZON_OVERFLOW":
      return TCEventCode.TC_EVENT_CODE_DECEL_HORIZON_OVERFLOW;
    case 11:
    case "TC_EVENT_CODE_IK_SINGULAR":
      return TCEventCode.TC_EVENT_CODE_IK_SINGULAR;
    case 12:
    case "TC_EVENT_CODE_IK_NO_SOLUTION":
      return TCEventCode.TC_EVENT_CODE_IK_NO_SOLUTION;
    case 13:
    case "TC_EVENT_CODE_IK_WARNING":
      return TCEventCode.TC_EVENT_CODE_IK_WARNING;
    case 14:
    case "TC_EVENT_CODE_NON_UNIT_QUATERNION":
      return TCEventCode.TC_EVENT_CODE_NON_UNIT_QUATERNION;
    case 15:
    case "TC_EVENT_CODE_INVALID_FILTER_GAIN":
      return TCEventCode.TC_EVENT_CODE_INVALID_FILTER_GAIN;
    case 16:
    case "TC_EVENT_CODE_ACCEL_LIMIT_EXCEEDED":
      return TCEventCode.TC_EVENT_CODE_ACCEL_LIMIT_EXCEEDED;
    case 17:
    case "TC_EVENT_CODE_FK_FAILED":
      return TCEventCode.TC_EVENT_CODE_FK_FAILED;
    case 18:
    case "TC_EVENT_CODE_JACOBIAN_INVALID":
      return TCEventCode.TC_EVENT_CODE_JACOBIAN_INVALID;
    case 19:
    case "TC_EVENT_CODE_JACOBIAN_SINGULAR":
      return TCEventCode.TC_EVENT_CODE_JACOBIAN_SINGULAR;
    case 20:
    case "TC_EVENT_CODE_POSE_JUMP_EXCEEDED":
      return TCEventCode.TC_EVENT_CODE_POSE_JUMP_EXCEEDED;
    case 21:
    case "TC_EVENT_CODE_TRACKER_ERROR_EXCEEDED":
      return TCEventCode.TC_EVENT_CODE_TRACKER_ERROR_EXCEEDED;
    case 22:
    case "TC_EVENT_CODE_TRACKER_GAIN_EXCEEDS_ACCEL":
      return TCEventCode.TC_EVENT_CODE_TRACKER_GAIN_EXCEEDS_ACCEL;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TCEventCode.UNRECOGNIZED;
  }
}

export function tCEventCodeToJSON(object: TCEventCode): string {
  switch (object) {
    case TCEventCode.TC_EVENT_CODE_UNSPECIFIED:
      return "TC_EVENT_CODE_UNSPECIFIED";
    case TCEventCode.TC_EVENT_CODE_INVALID_VELOCITY_CONSTRAINT:
      return "TC_EVENT_CODE_INVALID_VELOCITY_CONSTRAINT";
    case TCEventCode.TC_EVENT_CODE_MALFORMED_CONSTRAINT_LIST:
      return "TC_EVENT_CODE_MALFORMED_CONSTRAINT_LIST";
    case TCEventCode.TC_EVENT_CODE_INVALID_NOMINAL:
      return "TC_EVENT_CODE_INVALID_NOMINAL";
    case TCEventCode.TC_EVENT_CODE_BINDING_CONSTRAINT_CHANGED:
      return "TC_EVENT_CODE_BINDING_CONSTRAINT_CHANGED";
    case TCEventCode.TC_EVENT_CODE_DIVIDE_BY_ZERO:
      return "TC_EVENT_CODE_DIVIDE_BY_ZERO";
    case TCEventCode.TC_EVENT_CODE_NON_FINITE_INPUT:
      return "TC_EVENT_CODE_NON_FINITE_INPUT";
    case TCEventCode.TC_EVENT_CODE_NON_FINITE_OUTPUT:
      return "TC_EVENT_CODE_NON_FINITE_OUTPUT";
    case TCEventCode.TC_EVENT_CODE_COMMAND_TIMEOUT:
      return "TC_EVENT_CODE_COMMAND_TIMEOUT";
    case TCEventCode.TC_EVENT_CODE_NON_POSITIVE_LIMIT:
      return "TC_EVENT_CODE_NON_POSITIVE_LIMIT";
    case TCEventCode.TC_EVENT_CODE_DECEL_HORIZON_OVERFLOW:
      return "TC_EVENT_CODE_DECEL_HORIZON_OVERFLOW";
    case TCEventCode.TC_EVENT_CODE_IK_SINGULAR:
      return "TC_EVENT_CODE_IK_SINGULAR";
    case TCEventCode.TC_EVENT_CODE_IK_NO_SOLUTION:
      return "TC_EVENT_CODE_IK_NO_SOLUTION";
    case TCEventCode.TC_EVENT_CODE_IK_WARNING:
      return "TC_EVENT_CODE_IK_WARNING";
    case TCEventCode.TC_EVENT_CODE_NON_UNIT_QUATERNION:
      return "TC_EVENT_CODE_NON_UNIT_QUATERNION";
    case TCEventCode.TC_EVENT_CODE_INVALID_FILTER_GAIN:
      return "TC_EVENT_CODE_INVALID_FILTER_GAIN";
    case TCEventCode.TC_EVENT_CODE_ACCEL_LIMIT_EXCEEDED:
      return "TC_EVENT_CODE_ACCEL_LIMIT_EXCEEDED";
    case TCEventCode.TC_EVENT_CODE_FK_FAILED:
      return "TC_EVENT_CODE_FK_FAILED";
    case TCEventCode.TC_EVENT_CODE_JACOBIAN_INVALID:
      return "TC_EVENT_CODE_JACOBIAN_INVALID";
    case TCEventCode.TC_EVENT_CODE_JACOBIAN_SINGULAR:
      return "TC_EVENT_CODE_JACOBIAN_SINGULAR";
    case TCEventCode.TC_EVENT_CODE_POSE_JUMP_EXCEEDED:
      return "TC_EVENT_CODE_POSE_JUMP_EXCEEDED";
    case TCEventCode.TC_EVENT_CODE_TRACKER_ERROR_EXCEEDED:
      return "TC_EVENT_CODE_TRACKER_ERROR_EXCEEDED";
    case TCEventCode.TC_EVENT_CODE_TRACKER_GAIN_EXCEEDS_ACCEL:
      return "TC_EVENT_CODE_TRACKER_GAIN_EXCEEDS_ACCEL";
    case TCEventCode.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Collision telemetry in ControllerStateMsg. */
export enum CollisionZone {
  COLLISION_ZONE_UNKNOWN = 0,
  /** COLLISION_ZONE_SAFE - min_distance >= margin */
  COLLISION_ZONE_SAFE = 1,
  /** COLLISION_ZONE_MARGIN - 0 <= min_distance < margin */
  COLLISION_ZONE_MARGIN = 2,
  /** COLLISION_ZONE_PENETRATION - min_distance < 0 */
  COLLISION_ZONE_PENETRATION = 3,
  UNRECOGNIZED = -1,
}

export function collisionZoneFromJSON(object: any): CollisionZone {
  switch (object) {
    case 0:
    case "COLLISION_ZONE_UNKNOWN":
      return CollisionZone.COLLISION_ZONE_UNKNOWN;
    case 1:
    case "COLLISION_ZONE_SAFE":
      return CollisionZone.COLLISION_ZONE_SAFE;
    case 2:
    case "COLLISION_ZONE_MARGIN":
      return CollisionZone.COLLISION_ZONE_MARGIN;
    case 3:
    case "COLLISION_ZONE_PENETRATION":
      return CollisionZone.COLLISION_ZONE_PENETRATION;
    case -1:
    case "UNRECOGNIZED":
    default:
      return CollisionZone.UNRECOGNIZED;
  }
}

export function collisionZoneToJSON(object: CollisionZone): string {
  switch (object) {
    case CollisionZone.COLLISION_ZONE_UNKNOWN:
      return "COLLISION_ZONE_UNKNOWN";
    case CollisionZone.COLLISION_ZONE_SAFE:
      return "COLLISION_ZONE_SAFE";
    case CollisionZone.COLLISION_ZONE_MARGIN:
      return "COLLISION_ZONE_MARGIN";
    case CollisionZone.COLLISION_ZONE_PENETRATION:
      return "COLLISION_ZONE_PENETRATION";
    case CollisionZone.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * Linear and angular velocity of a frame.
 * Linear: meters/second.  Angular: radians/second.
 *
 * This message does not say which frame the velocity is in. The message that
 * carries a CartesianVelocity says that.
 */
export interface CartesianVelocity {
  linear: Vector3 | undefined;
  angular: Vector3 | undefined;
}

/**
 * Starts a position-streaming joint jog. Carries the stream settings and no
 * joint target: targets are supplied exclusively through
 * WriteServoJ(ServoJTarget), and the arm holds its commanded position until
 * the first one arrives.
 */
export interface ServoJ {
  /** First-order LPF gain on the streamed target. */
  kP: number;
  /** Staleness window before the stream is considered stale. */
  commandTimeoutMs: number;
  /** Smooth-start ramp from commanded position to the stream. */
  rampInDurationMs: number;
  /**
   * Position smoothing time constant, ms. When a streamed target differs from
   * the dead-reckoned prediction from the last position and velocity, the
   * difference decays exponentially with this time constant instead of being
   * applied in one control cycle, so stream cadence jitter becomes a small
   * position adjustment rather than a one-cycle velocity spike. 0 (and the
   * proto3 default when absent) = same-cycle reset. The TC rejects values
   * above 1000 ms at enqueue.
   */
  positionSmoothingTimeConstantMs: number;
}

/**
 * Starts a pose-streaming session. Carries the stream settings and no
 * pose target: targets are supplied exclusively through
 * WriteServoL(ServoLTarget), and the arm holds its commanded pose until the
 * first one arrives.
 *
 * All three frame slots are REQUIRED (unset → TC_ERROR_FRAME_NOT_SPECIFIED),
 * per-command and snapshotted at enqueue, with the same validation and error
 * codes as SpeedL:
 *   * reference:             frame the streamed pose is expressed in; parent must
 *                            be world-side (WORLD/BASE). Same side as
 *                            commanded_frame → TC_ERROR_INCOMPATIBLE_FRAMES.
 *   * commanded_frame:       the controlled point (flange→TCP offset) driven to the
 *                            streamed pose. parent must be FLANGE; CAMERA →
 *                            TC_ERROR_FRAME_NOT_SUPPORTED.
 *   * velocity_expressed_in: rotation-only frame selecting the axes the streamed
 *                            twist is resolved along.
 */
export interface ServoL {
  /** First-order LPF gain on the streamed target. */
  kP: number;
  /** Staleness window before the stream is considered stale. */
  commandTimeoutMs: number;
  /** Smooth-start ramp from commanded pose to the stream. */
  rampInDurationMs: number;
  reference: Frame | undefined;
  commandedFrame: Frame | undefined;
  velocityExpressedIn:
    | Orientation
    | undefined;
  /** Absent: no per-joint limits. */
  motionScalingLimits?: MotionScalingLimits | undefined;
}

export interface MotionScalingLimits {
  /** rad/s, length 6 */
  jointVelocityMax: number[];
  /** rad/s², length 6 */
  jointAccelerationMax: number[];
}

/**
 * Direction-only joint jog — speed at TC comes from snapshotted
 * JogConfig × slider × active SafetyLimits, composed at enqueue time.
 * Requires SetSafetySession and SetSpeedSlider to have been pushed at
 * least once before this primitive will be accepted.
 */
export interface SpeedJ {
  direction: JointDirection | undefined;
  collisionConfig?: CollisionConfig | undefined;
}

/**
 * A built-in reference frame plus a rigid offset expressed in that frame.
 * The frame in world coordinates is world_to_parent · pose_in_parent.
 *
 * The offset is REQUIRED: an unset slot (default zero quaternion) is rejected
 * with TC_ERROR_FRAME_NOT_SPECIFIED, never treated as identity.
 */
export interface Frame {
  parent: BuiltInFrame;
  /** rigid offset (position + orientation) of this frame, in `parent` coordinates */
  poseInParent: Pose | undefined;
}

/**
 * A built-in reference frame plus a rotation-only offset expressed in that
 * frame. It selects the axes a direction or streamed twist is resolved
 * along, so only orientation is meaningful (no translation). Same
 * required / fail-loud contract as Frame.
 */
export interface Orientation {
  parent: BuiltInFrame;
  /** rotation of this frame relative to `parent` */
  rotationInParent: Quaternion | undefined;
}

/**
 * Cartesian jog. `direction` is a one-hot ±1 axis; the TC sets the
 * linear/angular speed from snapshotted JogConfig × slider × SafetyLimits.
 * Same SetSafetySession + SetSpeedSlider prerequisites as SpeedJ.
 *
 * All three frame slots are REQUIRED (unset → TC_ERROR_FRAME_NOT_SPECIFIED),
 * per-command and snapshotted at enqueue:
 *   * reference:             frame the motion is actuated relative to; parent must
 *                            be world-side (WORLD/BASE). Same side as commanded_frame
 *                            → TC_ERROR_INCOMPATIBLE_FRAMES.
 *   * commanded_frame:       the controlled point (flange→TCP offset) — origin of the
 *                            rotational-jog pivot and where the TCP-linear limit binds.
 *                            parent must be FLANGE; CAMERA → TC_ERROR_FRAME_NOT_SUPPORTED.
 *   * velocity_expressed_in: rotation-only frame selecting the axes `direction` is
 *                            applied along (WORLD/BASE, identity rotation).
 */
export interface SpeedL {
  direction: CartesianDirection | undefined;
  reference: Frame | undefined;
  commandedFrame: Frame | undefined;
  velocityExpressedIn: Orientation | undefined;
  collisionConfig?: CollisionConfig | undefined;
}

export interface ExecuteTrajectory {
  trajectory: JointTrajectory | undefined;
}

export interface WorldToBaseUpdate {
  worldToBase: Pose | undefined;
}

export interface JointDirection {
  /** length 6 */
  entries: number[];
}

export interface CartesianDirection {
  /** length 3 */
  linear: number[];
  /** length 3 */
  angular: number[];
}

export interface Primitive {
  servoJ?: ServoJ | undefined;
  servoL?: ServoL | undefined;
  speedJ?: SpeedJ | undefined;
  speedL?: SpeedL | undefined;
  executeTrajectory?:
    | ExecuteTrajectory
    | undefined;
  /** sequenced settings command, not a motion primitive */
  worldToBaseUpdate?: WorldToBaseUpdate | undefined;
}

/**
 * Request information of which cardinal directions in the given frame
 * are feasible jog directions. Passed data matches subset of SpeedL request.
 */
export interface GetJogDirectionsRequest {
  reference: Frame | undefined;
  commandedFrame: Frame | undefined;
  velocityExpressedIn: Orientation | undefined;
}

/** Part of response to GetJogDirectionsRequest */
export interface JogDirectionResult {
  direction: CartesianDirection | undefined;
  feasible: boolean;
  error?: TCErrorCode | undefined;
}

/** Response to GetJogDirectionsRequest */
export interface GetJogDirectionsReply {
  results: JogDirectionResult[];
  error?: TCErrorCode | undefined;
}

export interface EnqueueReply {
  accepted: boolean;
  primitiveId?: number | undefined;
  error?: TCErrorCode | undefined;
}

export interface SafetyLimits {
  /** rad/s, length 6 */
  jointVelocityMax: number[];
  /** rad/s², length 6 */
  jointAccelerationMax: number[];
  /** Nm, length 6 */
  jointTorqueMax: number[];
  /** m/s */
  tcpLinearVelocityMax: number;
}

export interface SafetySession {
  fullSpeed: SafetyLimits | undefined;
  slowSpeed: SafetyLimits | undefined;
}

export interface SpeedSlider {
  /** [0, 1] */
  value: number;
}

export interface SetReply {
  accepted: boolean;
  error?: TCErrorCode | undefined;
}

export interface ControllerStateMsg {
  state: TCState;
  activePrimitiveId?: number | undefined;
  activePrimitiveType?: string | undefined;
  queueDepth: number;
  speedScaling: number;
  paused: boolean;
  stepCount: number;
  errors: TCErrorCode[];
  collisionStatus?: CollisionStatus | undefined;
}

export interface PrimitiveEventMsg {
  type: PrimitiveEventType;
  primitiveId?: number | undefined;
  error?: TCErrorCode | undefined;
}

/**
 * One control cycle's commanded joint state as the controller produced it,
 * before arm-control-bot's 200 Hz hardware loop resamples it onto CAN.
 * Diagnostic only, behind the "onlinePlannerCommandLogging" flag. One message
 * per cycle, suppressed ones included, so a gap in `tick` means messages were
 * lost in transit rather than never sent.
 */
export interface CommandedStateMsg {
  /**
   * Cycles since the controller was constructed. Contiguous; does not reset
   * when recording starts.
   */
  tick: number;
  /**
   * Stamped on the control thread at the cycle itself, CLOCK_REALTIME, same
   * epoch as the rest of the blackbox. Prefer it over MCAP log time, which is
   * quantized to the publisher's drain period.
   */
  timestamp:
    | Date
    | undefined;
  /** radians */
  positions: number[];
  /** radians/second */
  velocities: number[];
  /** radians/second^2 */
  accelerations: number[];
  /**
   * Not authorized to command this cycle (another control source, or the arm
   * braked / in antigravity / failed). Nothing was sent to hardware.
   */
  suppressed: boolean;
  /**
   * The previous cycle overran the control period. Not by itself a skipped
   * cycle — one that runs long and catches up sets this too. Real skips never
   * take a tick number; they show as a jump in `timestamp`.
   */
  overrun: boolean;
  /**
   * A setpoint the primitive had not seen before arrived this cycle. Arrival,
   * not consumption — see the oneof below.
   */
  targetFresh?:
    | boolean
    | undefined;
  /**
   * The inbound mailbox's write counter for the sampled value. A step above one
   * means setpoints landed between cycles and latest-wins overwrote them
   * unread, which nothing else here can show. Compare its total against the
   * sink/WriteServo* count. writeError() shares the counter, so a step can also
   * be a target rejected as malformed.
   */
  targetWriteSeq?: number | undefined;
  servojTarget?: ServoJTarget | undefined;
  servolTarget?: ServoLTarget | undefined;
}

/**
 * A streamed ServoJ setpoint. Both fields are required and are consumed as a
 * pair: the velocity advances the position target between commands
 * (first-order hold). You can get zero-order hold behavior by setting velocity
 * to zero. A target carrying only positions is dropped rather
 * than assumed to mean zero velocity.
 */
export interface ServoJTarget {
  /** Joint positions in radians. */
  targetJoints: number[];
  /** Joint velocities in radians/second. */
  targetJointVelocities: number[];
}

/**
 * A streamed ServoL setpoint. Both fields are required and are consumed as a
 * pair: the twist advances the pose target between commands (first-order
 * hold). You can get zero-order hold behavior by setting the twist to zero. A
 * target carrying only a pose is dropped rather than assumed to mean zero
 * twist.
 *
 * The frames come from the ServoL that started the stream: the pose is the
 * target pose of `commanded_frame` expressed in `reference`, and the twist is
 * the velocity of that same point expressed in `velocity_expressed_in`.
 */
export interface ServoLTarget {
  /** position in meters, orientation as a unit quaternion */
  poseStream:
    | Pose
    | undefined;
  /** linear in m/s, angular in rad/s */
  twistStream: CartesianVelocity | undefined;
}

/**
 * One TC notification, off the RT thread and onto the network.
 *
 * The payload slots carry the code-specific values the message template
 * substitutes: they are the flat TCEvent's int_A/int_B/int_C/float_A (a
 * condition needing more than three ints and one scalar gets a second code,
 * not a wider message — hence no float_b).
 *
 * Internal-only fields stay off the wire on purpose: producer_id and the
 * factory call site (file/line) are developer diagnostics, not external API.
 */
export interface TCEventMsg {
  code: TCEventCode;
  severity: TCSeverity;
  /**
   * Rendered from the code's message template with the payload substituted.
   * Rendered on the publisher thread — never on the 1 kHz control loop.
   */
  message: string;
  intA: number;
  intB: number;
  intC: number;
  floatA: number;
  /**
   * Monotonic per producer process, stamped by the publisher. Lets a consumer
   * detect loss between itself and the robot.
   */
  seq: number;
  /**
   * Events rejected at push since the producer started, because the event ring
   * was full. Ring-level and unattributed: there is no per-code breakdown.
   */
  droppedEvents: number;
  /**
   * CLOCK_MONOTONIC microseconds, stamped when the event was *raised* on the
   * control loop — not when it was drained. A drain-time stamp would be up to
   * one drain period late and identical across a batch, making 300 events in
   * 300 ms indistinguishable from a full second of the condition.
   */
  occurredAtUs: number;
  /**
   * Boot id, constant for the producer process. Without it an arm-control-bot
   * restart resets seq and dropped_events while a consumer's per-code
   * aggregation state persists, splicing two producer lifetimes into one total
   * and turning a mid-condition restart into a false "resolved".
   */
  producerEpoch: number;
}

/**
 * Per-primitive collision configuration.
 * Sent inside SpeedJ/SpeedL at Enqueue time.
 * No collision_config = collision disabled (margin defaults to 0).
 */
export interface CollisionConfig {
  /** meters; 0 = disabled */
  collisionMargin: number;
  /** allow jog out of already-colliding state */
  penetrationBypass: boolean;
  /** per-primitive ACM overrides */
  disabledPairs: DisabledCollisionPair[];
}

export interface DisabledCollisionPair {
  /** URDF link name: "upper_arm_link" */
  linkA: string;
  /** URDF link name: "forearm_link" */
  linkB: string;
}

export interface CollisionBody {
  /** manifest key: "onrobot_rg2", "dqc_connector" */
  label: string;
  /** offset from flange; omit = directly on flange */
  mount?: MountOffset | undefined;
}

export interface MountOffset {
  /** translation x (meters) */
  tx: number;
  /** translation y (meters) */
  ty: number;
  /** translation z (meters) */
  tz: number;
  /** rotation quaternion x */
  rx: number;
  /** rotation quaternion y */
  ry: number;
  /** rotation quaternion z */
  rz: number;
  /** rotation quaternion w */
  rw: number;
}

/**
 * Equipment config — session-level (like SafetySession).
 * Botman calls SetCollisionEquipment once when gripper changes.
 * TC snapshots at Enqueue.
 */
export interface CollisionEquipment {
  bodies: CollisionBody[];
}

export interface CollisionStatus {
  /** meters, inf if no checker */
  minDistance: number;
  /** link index (-1 if N/A) */
  closestLinkA: number;
  /** link index (-1 if N/A) */
  closestLinkB: number;
  /** true if COLLISION is binding constraint */
  collisionBinding: boolean;
  /** restrictiveness value (0 = not active) */
  rCollision: number;
  /** explicit zone classification */
  zone: CollisionZone;
}

function createBaseCartesianVelocity(): CartesianVelocity {
  return { linear: undefined, angular: undefined };
}

export const CartesianVelocity: MessageFns<CartesianVelocity> = {
  encode(message: CartesianVelocity, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.linear !== undefined) {
      Vector3.encode(message.linear, writer.uint32(10).fork()).join();
    }
    if (message.angular !== undefined) {
      Vector3.encode(message.angular, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CartesianVelocity {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCartesianVelocity();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.linear = Vector3.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.angular = Vector3.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CartesianVelocity {
    return {
      linear: isSet(object.linear) ? Vector3.fromJSON(object.linear) : undefined,
      angular: isSet(object.angular) ? Vector3.fromJSON(object.angular) : undefined,
    };
  },

  toJSON(message: CartesianVelocity): unknown {
    const obj: any = {};
    if (message.linear !== undefined) {
      obj.linear = Vector3.toJSON(message.linear);
    }
    if (message.angular !== undefined) {
      obj.angular = Vector3.toJSON(message.angular);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CartesianVelocity>, I>>(base?: I): CartesianVelocity {
    return CartesianVelocity.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CartesianVelocity>, I>>(object: I): CartesianVelocity {
    const message = createBaseCartesianVelocity();
    message.linear = (object.linear !== undefined && object.linear !== null)
      ? Vector3.fromPartial(object.linear)
      : undefined;
    message.angular = (object.angular !== undefined && object.angular !== null)
      ? Vector3.fromPartial(object.angular)
      : undefined;
    return message;
  },
};

function createBaseServoJ(): ServoJ {
  return { kP: 0, commandTimeoutMs: 0, rampInDurationMs: 0, positionSmoothingTimeConstantMs: 0 };
}

export const ServoJ: MessageFns<ServoJ> = {
  encode(message: ServoJ, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.kP !== 0) {
      writer.uint32(9).double(message.kP);
    }
    if (message.commandTimeoutMs !== 0) {
      writer.uint32(16).uint32(message.commandTimeoutMs);
    }
    if (message.rampInDurationMs !== 0) {
      writer.uint32(24).uint32(message.rampInDurationMs);
    }
    if (message.positionSmoothingTimeConstantMs !== 0) {
      writer.uint32(32).uint32(message.positionSmoothingTimeConstantMs);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServoJ {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServoJ();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.kP = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.commandTimeoutMs = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.rampInDurationMs = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.positionSmoothingTimeConstantMs = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServoJ {
    return {
      kP: isSet(object.kP) ? globalThis.Number(object.kP) : 0,
      commandTimeoutMs: isSet(object.commandTimeoutMs) ? globalThis.Number(object.commandTimeoutMs) : 0,
      rampInDurationMs: isSet(object.rampInDurationMs) ? globalThis.Number(object.rampInDurationMs) : 0,
      positionSmoothingTimeConstantMs: isSet(object.positionSmoothingTimeConstantMs)
        ? globalThis.Number(object.positionSmoothingTimeConstantMs)
        : 0,
    };
  },

  toJSON(message: ServoJ): unknown {
    const obj: any = {};
    if (message.kP !== 0) {
      obj.kP = message.kP;
    }
    if (message.commandTimeoutMs !== 0) {
      obj.commandTimeoutMs = Math.round(message.commandTimeoutMs);
    }
    if (message.rampInDurationMs !== 0) {
      obj.rampInDurationMs = Math.round(message.rampInDurationMs);
    }
    if (message.positionSmoothingTimeConstantMs !== 0) {
      obj.positionSmoothingTimeConstantMs = Math.round(message.positionSmoothingTimeConstantMs);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServoJ>, I>>(base?: I): ServoJ {
    return ServoJ.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServoJ>, I>>(object: I): ServoJ {
    const message = createBaseServoJ();
    message.kP = object.kP ?? 0;
    message.commandTimeoutMs = object.commandTimeoutMs ?? 0;
    message.rampInDurationMs = object.rampInDurationMs ?? 0;
    message.positionSmoothingTimeConstantMs = object.positionSmoothingTimeConstantMs ?? 0;
    return message;
  },
};

function createBaseServoL(): ServoL {
  return {
    kP: 0,
    commandTimeoutMs: 0,
    rampInDurationMs: 0,
    reference: undefined,
    commandedFrame: undefined,
    velocityExpressedIn: undefined,
    motionScalingLimits: undefined,
  };
}

export const ServoL: MessageFns<ServoL> = {
  encode(message: ServoL, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.kP !== 0) {
      writer.uint32(9).double(message.kP);
    }
    if (message.commandTimeoutMs !== 0) {
      writer.uint32(16).uint32(message.commandTimeoutMs);
    }
    if (message.rampInDurationMs !== 0) {
      writer.uint32(24).uint32(message.rampInDurationMs);
    }
    if (message.reference !== undefined) {
      Frame.encode(message.reference, writer.uint32(34).fork()).join();
    }
    if (message.commandedFrame !== undefined) {
      Frame.encode(message.commandedFrame, writer.uint32(42).fork()).join();
    }
    if (message.velocityExpressedIn !== undefined) {
      Orientation.encode(message.velocityExpressedIn, writer.uint32(50).fork()).join();
    }
    if (message.motionScalingLimits !== undefined) {
      MotionScalingLimits.encode(message.motionScalingLimits, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServoL {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServoL();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.kP = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.commandTimeoutMs = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.rampInDurationMs = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.reference = Frame.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.commandedFrame = Frame.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.velocityExpressedIn = Orientation.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.motionScalingLimits = MotionScalingLimits.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServoL {
    return {
      kP: isSet(object.kP) ? globalThis.Number(object.kP) : 0,
      commandTimeoutMs: isSet(object.commandTimeoutMs) ? globalThis.Number(object.commandTimeoutMs) : 0,
      rampInDurationMs: isSet(object.rampInDurationMs) ? globalThis.Number(object.rampInDurationMs) : 0,
      reference: isSet(object.reference) ? Frame.fromJSON(object.reference) : undefined,
      commandedFrame: isSet(object.commandedFrame) ? Frame.fromJSON(object.commandedFrame) : undefined,
      velocityExpressedIn: isSet(object.velocityExpressedIn)
        ? Orientation.fromJSON(object.velocityExpressedIn)
        : undefined,
      motionScalingLimits: isSet(object.motionScalingLimits)
        ? MotionScalingLimits.fromJSON(object.motionScalingLimits)
        : undefined,
    };
  },

  toJSON(message: ServoL): unknown {
    const obj: any = {};
    if (message.kP !== 0) {
      obj.kP = message.kP;
    }
    if (message.commandTimeoutMs !== 0) {
      obj.commandTimeoutMs = Math.round(message.commandTimeoutMs);
    }
    if (message.rampInDurationMs !== 0) {
      obj.rampInDurationMs = Math.round(message.rampInDurationMs);
    }
    if (message.reference !== undefined) {
      obj.reference = Frame.toJSON(message.reference);
    }
    if (message.commandedFrame !== undefined) {
      obj.commandedFrame = Frame.toJSON(message.commandedFrame);
    }
    if (message.velocityExpressedIn !== undefined) {
      obj.velocityExpressedIn = Orientation.toJSON(message.velocityExpressedIn);
    }
    if (message.motionScalingLimits !== undefined) {
      obj.motionScalingLimits = MotionScalingLimits.toJSON(message.motionScalingLimits);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServoL>, I>>(base?: I): ServoL {
    return ServoL.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServoL>, I>>(object: I): ServoL {
    const message = createBaseServoL();
    message.kP = object.kP ?? 0;
    message.commandTimeoutMs = object.commandTimeoutMs ?? 0;
    message.rampInDurationMs = object.rampInDurationMs ?? 0;
    message.reference = (object.reference !== undefined && object.reference !== null)
      ? Frame.fromPartial(object.reference)
      : undefined;
    message.commandedFrame = (object.commandedFrame !== undefined && object.commandedFrame !== null)
      ? Frame.fromPartial(object.commandedFrame)
      : undefined;
    message.velocityExpressedIn = (object.velocityExpressedIn !== undefined && object.velocityExpressedIn !== null)
      ? Orientation.fromPartial(object.velocityExpressedIn)
      : undefined;
    message.motionScalingLimits = (object.motionScalingLimits !== undefined && object.motionScalingLimits !== null)
      ? MotionScalingLimits.fromPartial(object.motionScalingLimits)
      : undefined;
    return message;
  },
};

function createBaseMotionScalingLimits(): MotionScalingLimits {
  return { jointVelocityMax: [], jointAccelerationMax: [] };
}

export const MotionScalingLimits: MessageFns<MotionScalingLimits> = {
  encode(message: MotionScalingLimits, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    writer.uint32(10).fork();
    for (const v of message.jointVelocityMax) {
      writer.double(v);
    }
    writer.join();
    writer.uint32(18).fork();
    for (const v of message.jointAccelerationMax) {
      writer.double(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MotionScalingLimits {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMotionScalingLimits();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag === 9) {
            message.jointVelocityMax.push(reader.double());

            continue;
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.jointVelocityMax.push(reader.double());
            }

            continue;
          }

          break;
        }
        case 2: {
          if (tag === 17) {
            message.jointAccelerationMax.push(reader.double());

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.jointAccelerationMax.push(reader.double());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MotionScalingLimits {
    return {
      jointVelocityMax: globalThis.Array.isArray(object?.jointVelocityMax)
        ? object.jointVelocityMax.map((e: any) => globalThis.Number(e))
        : [],
      jointAccelerationMax: globalThis.Array.isArray(object?.jointAccelerationMax)
        ? object.jointAccelerationMax.map((e: any) => globalThis.Number(e))
        : [],
    };
  },

  toJSON(message: MotionScalingLimits): unknown {
    const obj: any = {};
    if (message.jointVelocityMax?.length) {
      obj.jointVelocityMax = message.jointVelocityMax;
    }
    if (message.jointAccelerationMax?.length) {
      obj.jointAccelerationMax = message.jointAccelerationMax;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MotionScalingLimits>, I>>(base?: I): MotionScalingLimits {
    return MotionScalingLimits.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MotionScalingLimits>, I>>(object: I): MotionScalingLimits {
    const message = createBaseMotionScalingLimits();
    message.jointVelocityMax = object.jointVelocityMax?.map((e) => e) || [];
    message.jointAccelerationMax = object.jointAccelerationMax?.map((e) => e) || [];
    return message;
  },
};

function createBaseSpeedJ(): SpeedJ {
  return { direction: undefined, collisionConfig: undefined };
}

export const SpeedJ: MessageFns<SpeedJ> = {
  encode(message: SpeedJ, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.direction !== undefined) {
      JointDirection.encode(message.direction, writer.uint32(10).fork()).join();
    }
    if (message.collisionConfig !== undefined) {
      CollisionConfig.encode(message.collisionConfig, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpeedJ {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpeedJ();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.direction = JointDirection.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.collisionConfig = CollisionConfig.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpeedJ {
    return {
      direction: isSet(object.direction) ? JointDirection.fromJSON(object.direction) : undefined,
      collisionConfig: isSet(object.collisionConfig) ? CollisionConfig.fromJSON(object.collisionConfig) : undefined,
    };
  },

  toJSON(message: SpeedJ): unknown {
    const obj: any = {};
    if (message.direction !== undefined) {
      obj.direction = JointDirection.toJSON(message.direction);
    }
    if (message.collisionConfig !== undefined) {
      obj.collisionConfig = CollisionConfig.toJSON(message.collisionConfig);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpeedJ>, I>>(base?: I): SpeedJ {
    return SpeedJ.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpeedJ>, I>>(object: I): SpeedJ {
    const message = createBaseSpeedJ();
    message.direction = (object.direction !== undefined && object.direction !== null)
      ? JointDirection.fromPartial(object.direction)
      : undefined;
    message.collisionConfig = (object.collisionConfig !== undefined && object.collisionConfig !== null)
      ? CollisionConfig.fromPartial(object.collisionConfig)
      : undefined;
    return message;
  },
};

function createBaseFrame(): Frame {
  return { parent: 0, poseInParent: undefined };
}

export const Frame: MessageFns<Frame> = {
  encode(message: Frame, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.parent !== 0) {
      writer.uint32(8).int32(message.parent);
    }
    if (message.poseInParent !== undefined) {
      Pose.encode(message.poseInParent, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Frame {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFrame();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.parent = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.poseInParent = Pose.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Frame {
    return {
      parent: isSet(object.parent) ? builtInFrameFromJSON(object.parent) : 0,
      poseInParent: isSet(object.poseInParent) ? Pose.fromJSON(object.poseInParent) : undefined,
    };
  },

  toJSON(message: Frame): unknown {
    const obj: any = {};
    if (message.parent !== 0) {
      obj.parent = builtInFrameToJSON(message.parent);
    }
    if (message.poseInParent !== undefined) {
      obj.poseInParent = Pose.toJSON(message.poseInParent);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Frame>, I>>(base?: I): Frame {
    return Frame.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Frame>, I>>(object: I): Frame {
    const message = createBaseFrame();
    message.parent = object.parent ?? 0;
    message.poseInParent = (object.poseInParent !== undefined && object.poseInParent !== null)
      ? Pose.fromPartial(object.poseInParent)
      : undefined;
    return message;
  },
};

function createBaseOrientation(): Orientation {
  return { parent: 0, rotationInParent: undefined };
}

export const Orientation: MessageFns<Orientation> = {
  encode(message: Orientation, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.parent !== 0) {
      writer.uint32(8).int32(message.parent);
    }
    if (message.rotationInParent !== undefined) {
      Quaternion.encode(message.rotationInParent, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Orientation {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrientation();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.parent = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.rotationInParent = Quaternion.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Orientation {
    return {
      parent: isSet(object.parent) ? builtInFrameFromJSON(object.parent) : 0,
      rotationInParent: isSet(object.rotationInParent) ? Quaternion.fromJSON(object.rotationInParent) : undefined,
    };
  },

  toJSON(message: Orientation): unknown {
    const obj: any = {};
    if (message.parent !== 0) {
      obj.parent = builtInFrameToJSON(message.parent);
    }
    if (message.rotationInParent !== undefined) {
      obj.rotationInParent = Quaternion.toJSON(message.rotationInParent);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Orientation>, I>>(base?: I): Orientation {
    return Orientation.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Orientation>, I>>(object: I): Orientation {
    const message = createBaseOrientation();
    message.parent = object.parent ?? 0;
    message.rotationInParent = (object.rotationInParent !== undefined && object.rotationInParent !== null)
      ? Quaternion.fromPartial(object.rotationInParent)
      : undefined;
    return message;
  },
};

function createBaseSpeedL(): SpeedL {
  return {
    direction: undefined,
    reference: undefined,
    commandedFrame: undefined,
    velocityExpressedIn: undefined,
    collisionConfig: undefined,
  };
}

export const SpeedL: MessageFns<SpeedL> = {
  encode(message: SpeedL, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.direction !== undefined) {
      CartesianDirection.encode(message.direction, writer.uint32(10).fork()).join();
    }
    if (message.reference !== undefined) {
      Frame.encode(message.reference, writer.uint32(18).fork()).join();
    }
    if (message.commandedFrame !== undefined) {
      Frame.encode(message.commandedFrame, writer.uint32(26).fork()).join();
    }
    if (message.velocityExpressedIn !== undefined) {
      Orientation.encode(message.velocityExpressedIn, writer.uint32(34).fork()).join();
    }
    if (message.collisionConfig !== undefined) {
      CollisionConfig.encode(message.collisionConfig, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpeedL {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpeedL();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.direction = CartesianDirection.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.reference = Frame.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.commandedFrame = Frame.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.velocityExpressedIn = Orientation.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.collisionConfig = CollisionConfig.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpeedL {
    return {
      direction: isSet(object.direction) ? CartesianDirection.fromJSON(object.direction) : undefined,
      reference: isSet(object.reference) ? Frame.fromJSON(object.reference) : undefined,
      commandedFrame: isSet(object.commandedFrame) ? Frame.fromJSON(object.commandedFrame) : undefined,
      velocityExpressedIn: isSet(object.velocityExpressedIn)
        ? Orientation.fromJSON(object.velocityExpressedIn)
        : undefined,
      collisionConfig: isSet(object.collisionConfig) ? CollisionConfig.fromJSON(object.collisionConfig) : undefined,
    };
  },

  toJSON(message: SpeedL): unknown {
    const obj: any = {};
    if (message.direction !== undefined) {
      obj.direction = CartesianDirection.toJSON(message.direction);
    }
    if (message.reference !== undefined) {
      obj.reference = Frame.toJSON(message.reference);
    }
    if (message.commandedFrame !== undefined) {
      obj.commandedFrame = Frame.toJSON(message.commandedFrame);
    }
    if (message.velocityExpressedIn !== undefined) {
      obj.velocityExpressedIn = Orientation.toJSON(message.velocityExpressedIn);
    }
    if (message.collisionConfig !== undefined) {
      obj.collisionConfig = CollisionConfig.toJSON(message.collisionConfig);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpeedL>, I>>(base?: I): SpeedL {
    return SpeedL.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpeedL>, I>>(object: I): SpeedL {
    const message = createBaseSpeedL();
    message.direction = (object.direction !== undefined && object.direction !== null)
      ? CartesianDirection.fromPartial(object.direction)
      : undefined;
    message.reference = (object.reference !== undefined && object.reference !== null)
      ? Frame.fromPartial(object.reference)
      : undefined;
    message.commandedFrame = (object.commandedFrame !== undefined && object.commandedFrame !== null)
      ? Frame.fromPartial(object.commandedFrame)
      : undefined;
    message.velocityExpressedIn = (object.velocityExpressedIn !== undefined && object.velocityExpressedIn !== null)
      ? Orientation.fromPartial(object.velocityExpressedIn)
      : undefined;
    message.collisionConfig = (object.collisionConfig !== undefined && object.collisionConfig !== null)
      ? CollisionConfig.fromPartial(object.collisionConfig)
      : undefined;
    return message;
  },
};

function createBaseExecuteTrajectory(): ExecuteTrajectory {
  return { trajectory: undefined };
}

export const ExecuteTrajectory: MessageFns<ExecuteTrajectory> = {
  encode(message: ExecuteTrajectory, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.trajectory !== undefined) {
      JointTrajectory.encode(message.trajectory, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExecuteTrajectory {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExecuteTrajectory();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.trajectory = JointTrajectory.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ExecuteTrajectory {
    return { trajectory: isSet(object.trajectory) ? JointTrajectory.fromJSON(object.trajectory) : undefined };
  },

  toJSON(message: ExecuteTrajectory): unknown {
    const obj: any = {};
    if (message.trajectory !== undefined) {
      obj.trajectory = JointTrajectory.toJSON(message.trajectory);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ExecuteTrajectory>, I>>(base?: I): ExecuteTrajectory {
    return ExecuteTrajectory.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ExecuteTrajectory>, I>>(object: I): ExecuteTrajectory {
    const message = createBaseExecuteTrajectory();
    message.trajectory = (object.trajectory !== undefined && object.trajectory !== null)
      ? JointTrajectory.fromPartial(object.trajectory)
      : undefined;
    return message;
  },
};

function createBaseWorldToBaseUpdate(): WorldToBaseUpdate {
  return { worldToBase: undefined };
}

export const WorldToBaseUpdate: MessageFns<WorldToBaseUpdate> = {
  encode(message: WorldToBaseUpdate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.worldToBase !== undefined) {
      Pose.encode(message.worldToBase, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WorldToBaseUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWorldToBaseUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.worldToBase = Pose.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WorldToBaseUpdate {
    return { worldToBase: isSet(object.worldToBase) ? Pose.fromJSON(object.worldToBase) : undefined };
  },

  toJSON(message: WorldToBaseUpdate): unknown {
    const obj: any = {};
    if (message.worldToBase !== undefined) {
      obj.worldToBase = Pose.toJSON(message.worldToBase);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WorldToBaseUpdate>, I>>(base?: I): WorldToBaseUpdate {
    return WorldToBaseUpdate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WorldToBaseUpdate>, I>>(object: I): WorldToBaseUpdate {
    const message = createBaseWorldToBaseUpdate();
    message.worldToBase = (object.worldToBase !== undefined && object.worldToBase !== null)
      ? Pose.fromPartial(object.worldToBase)
      : undefined;
    return message;
  },
};

function createBaseJointDirection(): JointDirection {
  return { entries: [] };
}

export const JointDirection: MessageFns<JointDirection> = {
  encode(message: JointDirection, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    writer.uint32(10).fork();
    for (const v of message.entries) {
      writer.sint32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JointDirection {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJointDirection();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag === 8) {
            message.entries.push(reader.sint32());

            continue;
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.entries.push(reader.sint32());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JointDirection {
    return {
      entries: globalThis.Array.isArray(object?.entries) ? object.entries.map((e: any) => globalThis.Number(e)) : [],
    };
  },

  toJSON(message: JointDirection): unknown {
    const obj: any = {};
    if (message.entries?.length) {
      obj.entries = message.entries.map((e) => Math.round(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JointDirection>, I>>(base?: I): JointDirection {
    return JointDirection.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JointDirection>, I>>(object: I): JointDirection {
    const message = createBaseJointDirection();
    message.entries = object.entries?.map((e) => e) || [];
    return message;
  },
};

function createBaseCartesianDirection(): CartesianDirection {
  return { linear: [], angular: [] };
}

export const CartesianDirection: MessageFns<CartesianDirection> = {
  encode(message: CartesianDirection, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    writer.uint32(10).fork();
    for (const v of message.linear) {
      writer.sint32(v);
    }
    writer.join();
    writer.uint32(18).fork();
    for (const v of message.angular) {
      writer.sint32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CartesianDirection {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCartesianDirection();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag === 8) {
            message.linear.push(reader.sint32());

            continue;
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.linear.push(reader.sint32());
            }

            continue;
          }

          break;
        }
        case 2: {
          if (tag === 16) {
            message.angular.push(reader.sint32());

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.angular.push(reader.sint32());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CartesianDirection {
    return {
      linear: globalThis.Array.isArray(object?.linear) ? object.linear.map((e: any) => globalThis.Number(e)) : [],
      angular: globalThis.Array.isArray(object?.angular) ? object.angular.map((e: any) => globalThis.Number(e)) : [],
    };
  },

  toJSON(message: CartesianDirection): unknown {
    const obj: any = {};
    if (message.linear?.length) {
      obj.linear = message.linear.map((e) => Math.round(e));
    }
    if (message.angular?.length) {
      obj.angular = message.angular.map((e) => Math.round(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CartesianDirection>, I>>(base?: I): CartesianDirection {
    return CartesianDirection.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CartesianDirection>, I>>(object: I): CartesianDirection {
    const message = createBaseCartesianDirection();
    message.linear = object.linear?.map((e) => e) || [];
    message.angular = object.angular?.map((e) => e) || [];
    return message;
  },
};

function createBasePrimitive(): Primitive {
  return {
    servoJ: undefined,
    servoL: undefined,
    speedJ: undefined,
    speedL: undefined,
    executeTrajectory: undefined,
    worldToBaseUpdate: undefined,
  };
}

export const Primitive: MessageFns<Primitive> = {
  encode(message: Primitive, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.servoJ !== undefined) {
      ServoJ.encode(message.servoJ, writer.uint32(10).fork()).join();
    }
    if (message.servoL !== undefined) {
      ServoL.encode(message.servoL, writer.uint32(18).fork()).join();
    }
    if (message.speedJ !== undefined) {
      SpeedJ.encode(message.speedJ, writer.uint32(26).fork()).join();
    }
    if (message.speedL !== undefined) {
      SpeedL.encode(message.speedL, writer.uint32(34).fork()).join();
    }
    if (message.executeTrajectory !== undefined) {
      ExecuteTrajectory.encode(message.executeTrajectory, writer.uint32(42).fork()).join();
    }
    if (message.worldToBaseUpdate !== undefined) {
      WorldToBaseUpdate.encode(message.worldToBaseUpdate, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Primitive {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePrimitive();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.servoJ = ServoJ.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.servoL = ServoL.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.speedJ = SpeedJ.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.speedL = SpeedL.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.executeTrajectory = ExecuteTrajectory.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.worldToBaseUpdate = WorldToBaseUpdate.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Primitive {
    return {
      servoJ: isSet(object.servoJ) ? ServoJ.fromJSON(object.servoJ) : undefined,
      servoL: isSet(object.servoL) ? ServoL.fromJSON(object.servoL) : undefined,
      speedJ: isSet(object.speedJ) ? SpeedJ.fromJSON(object.speedJ) : undefined,
      speedL: isSet(object.speedL) ? SpeedL.fromJSON(object.speedL) : undefined,
      executeTrajectory: isSet(object.executeTrajectory)
        ? ExecuteTrajectory.fromJSON(object.executeTrajectory)
        : undefined,
      worldToBaseUpdate: isSet(object.worldToBaseUpdate)
        ? WorldToBaseUpdate.fromJSON(object.worldToBaseUpdate)
        : undefined,
    };
  },

  toJSON(message: Primitive): unknown {
    const obj: any = {};
    if (message.servoJ !== undefined) {
      obj.servoJ = ServoJ.toJSON(message.servoJ);
    }
    if (message.servoL !== undefined) {
      obj.servoL = ServoL.toJSON(message.servoL);
    }
    if (message.speedJ !== undefined) {
      obj.speedJ = SpeedJ.toJSON(message.speedJ);
    }
    if (message.speedL !== undefined) {
      obj.speedL = SpeedL.toJSON(message.speedL);
    }
    if (message.executeTrajectory !== undefined) {
      obj.executeTrajectory = ExecuteTrajectory.toJSON(message.executeTrajectory);
    }
    if (message.worldToBaseUpdate !== undefined) {
      obj.worldToBaseUpdate = WorldToBaseUpdate.toJSON(message.worldToBaseUpdate);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Primitive>, I>>(base?: I): Primitive {
    return Primitive.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Primitive>, I>>(object: I): Primitive {
    const message = createBasePrimitive();
    message.servoJ = (object.servoJ !== undefined && object.servoJ !== null)
      ? ServoJ.fromPartial(object.servoJ)
      : undefined;
    message.servoL = (object.servoL !== undefined && object.servoL !== null)
      ? ServoL.fromPartial(object.servoL)
      : undefined;
    message.speedJ = (object.speedJ !== undefined && object.speedJ !== null)
      ? SpeedJ.fromPartial(object.speedJ)
      : undefined;
    message.speedL = (object.speedL !== undefined && object.speedL !== null)
      ? SpeedL.fromPartial(object.speedL)
      : undefined;
    message.executeTrajectory = (object.executeTrajectory !== undefined && object.executeTrajectory !== null)
      ? ExecuteTrajectory.fromPartial(object.executeTrajectory)
      : undefined;
    message.worldToBaseUpdate = (object.worldToBaseUpdate !== undefined && object.worldToBaseUpdate !== null)
      ? WorldToBaseUpdate.fromPartial(object.worldToBaseUpdate)
      : undefined;
    return message;
  },
};

function createBaseGetJogDirectionsRequest(): GetJogDirectionsRequest {
  return { reference: undefined, commandedFrame: undefined, velocityExpressedIn: undefined };
}

export const GetJogDirectionsRequest: MessageFns<GetJogDirectionsRequest> = {
  encode(message: GetJogDirectionsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.reference !== undefined) {
      Frame.encode(message.reference, writer.uint32(10).fork()).join();
    }
    if (message.commandedFrame !== undefined) {
      Frame.encode(message.commandedFrame, writer.uint32(18).fork()).join();
    }
    if (message.velocityExpressedIn !== undefined) {
      Orientation.encode(message.velocityExpressedIn, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetJogDirectionsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetJogDirectionsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.reference = Frame.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.commandedFrame = Frame.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.velocityExpressedIn = Orientation.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetJogDirectionsRequest {
    return {
      reference: isSet(object.reference) ? Frame.fromJSON(object.reference) : undefined,
      commandedFrame: isSet(object.commandedFrame) ? Frame.fromJSON(object.commandedFrame) : undefined,
      velocityExpressedIn: isSet(object.velocityExpressedIn)
        ? Orientation.fromJSON(object.velocityExpressedIn)
        : undefined,
    };
  },

  toJSON(message: GetJogDirectionsRequest): unknown {
    const obj: any = {};
    if (message.reference !== undefined) {
      obj.reference = Frame.toJSON(message.reference);
    }
    if (message.commandedFrame !== undefined) {
      obj.commandedFrame = Frame.toJSON(message.commandedFrame);
    }
    if (message.velocityExpressedIn !== undefined) {
      obj.velocityExpressedIn = Orientation.toJSON(message.velocityExpressedIn);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetJogDirectionsRequest>, I>>(base?: I): GetJogDirectionsRequest {
    return GetJogDirectionsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetJogDirectionsRequest>, I>>(object: I): GetJogDirectionsRequest {
    const message = createBaseGetJogDirectionsRequest();
    message.reference = (object.reference !== undefined && object.reference !== null)
      ? Frame.fromPartial(object.reference)
      : undefined;
    message.commandedFrame = (object.commandedFrame !== undefined && object.commandedFrame !== null)
      ? Frame.fromPartial(object.commandedFrame)
      : undefined;
    message.velocityExpressedIn = (object.velocityExpressedIn !== undefined && object.velocityExpressedIn !== null)
      ? Orientation.fromPartial(object.velocityExpressedIn)
      : undefined;
    return message;
  },
};

function createBaseJogDirectionResult(): JogDirectionResult {
  return { direction: undefined, feasible: false, error: undefined };
}

export const JogDirectionResult: MessageFns<JogDirectionResult> = {
  encode(message: JogDirectionResult, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.direction !== undefined) {
      CartesianDirection.encode(message.direction, writer.uint32(10).fork()).join();
    }
    if (message.feasible !== false) {
      writer.uint32(16).bool(message.feasible);
    }
    if (message.error !== undefined) {
      writer.uint32(24).int32(message.error);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JogDirectionResult {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJogDirectionResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.direction = CartesianDirection.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.feasible = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.error = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JogDirectionResult {
    return {
      direction: isSet(object.direction) ? CartesianDirection.fromJSON(object.direction) : undefined,
      feasible: isSet(object.feasible) ? globalThis.Boolean(object.feasible) : false,
      error: isSet(object.error) ? tCErrorCodeFromJSON(object.error) : undefined,
    };
  },

  toJSON(message: JogDirectionResult): unknown {
    const obj: any = {};
    if (message.direction !== undefined) {
      obj.direction = CartesianDirection.toJSON(message.direction);
    }
    if (message.feasible !== false) {
      obj.feasible = message.feasible;
    }
    if (message.error !== undefined) {
      obj.error = tCErrorCodeToJSON(message.error);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JogDirectionResult>, I>>(base?: I): JogDirectionResult {
    return JogDirectionResult.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JogDirectionResult>, I>>(object: I): JogDirectionResult {
    const message = createBaseJogDirectionResult();
    message.direction = (object.direction !== undefined && object.direction !== null)
      ? CartesianDirection.fromPartial(object.direction)
      : undefined;
    message.feasible = object.feasible ?? false;
    message.error = object.error ?? undefined;
    return message;
  },
};

function createBaseGetJogDirectionsReply(): GetJogDirectionsReply {
  return { results: [], error: undefined };
}

export const GetJogDirectionsReply: MessageFns<GetJogDirectionsReply> = {
  encode(message: GetJogDirectionsReply, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.results) {
      JogDirectionResult.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.error !== undefined) {
      writer.uint32(16).int32(message.error);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetJogDirectionsReply {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetJogDirectionsReply();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.results.push(JogDirectionResult.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.error = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetJogDirectionsReply {
    return {
      results: globalThis.Array.isArray(object?.results)
        ? object.results.map((e: any) => JogDirectionResult.fromJSON(e))
        : [],
      error: isSet(object.error) ? tCErrorCodeFromJSON(object.error) : undefined,
    };
  },

  toJSON(message: GetJogDirectionsReply): unknown {
    const obj: any = {};
    if (message.results?.length) {
      obj.results = message.results.map((e) => JogDirectionResult.toJSON(e));
    }
    if (message.error !== undefined) {
      obj.error = tCErrorCodeToJSON(message.error);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetJogDirectionsReply>, I>>(base?: I): GetJogDirectionsReply {
    return GetJogDirectionsReply.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetJogDirectionsReply>, I>>(object: I): GetJogDirectionsReply {
    const message = createBaseGetJogDirectionsReply();
    message.results = object.results?.map((e) => JogDirectionResult.fromPartial(e)) || [];
    message.error = object.error ?? undefined;
    return message;
  },
};

function createBaseEnqueueReply(): EnqueueReply {
  return { accepted: false, primitiveId: undefined, error: undefined };
}

export const EnqueueReply: MessageFns<EnqueueReply> = {
  encode(message: EnqueueReply, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accepted !== false) {
      writer.uint32(8).bool(message.accepted);
    }
    if (message.primitiveId !== undefined) {
      writer.uint32(16).uint64(message.primitiveId);
    }
    if (message.error !== undefined) {
      writer.uint32(24).int32(message.error);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EnqueueReply {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEnqueueReply();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.accepted = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.primitiveId = longToNumber(reader.uint64());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.error = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EnqueueReply {
    return {
      accepted: isSet(object.accepted) ? globalThis.Boolean(object.accepted) : false,
      primitiveId: isSet(object.primitiveId) ? globalThis.Number(object.primitiveId) : undefined,
      error: isSet(object.error) ? tCErrorCodeFromJSON(object.error) : undefined,
    };
  },

  toJSON(message: EnqueueReply): unknown {
    const obj: any = {};
    if (message.accepted !== false) {
      obj.accepted = message.accepted;
    }
    if (message.primitiveId !== undefined) {
      obj.primitiveId = Math.round(message.primitiveId);
    }
    if (message.error !== undefined) {
      obj.error = tCErrorCodeToJSON(message.error);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EnqueueReply>, I>>(base?: I): EnqueueReply {
    return EnqueueReply.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EnqueueReply>, I>>(object: I): EnqueueReply {
    const message = createBaseEnqueueReply();
    message.accepted = object.accepted ?? false;
    message.primitiveId = object.primitiveId ?? undefined;
    message.error = object.error ?? undefined;
    return message;
  },
};

function createBaseSafetyLimits(): SafetyLimits {
  return { jointVelocityMax: [], jointAccelerationMax: [], jointTorqueMax: [], tcpLinearVelocityMax: 0 };
}

export const SafetyLimits: MessageFns<SafetyLimits> = {
  encode(message: SafetyLimits, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    writer.uint32(10).fork();
    for (const v of message.jointVelocityMax) {
      writer.double(v);
    }
    writer.join();
    writer.uint32(18).fork();
    for (const v of message.jointAccelerationMax) {
      writer.double(v);
    }
    writer.join();
    writer.uint32(26).fork();
    for (const v of message.jointTorqueMax) {
      writer.double(v);
    }
    writer.join();
    if (message.tcpLinearVelocityMax !== 0) {
      writer.uint32(33).double(message.tcpLinearVelocityMax);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SafetyLimits {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSafetyLimits();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag === 9) {
            message.jointVelocityMax.push(reader.double());

            continue;
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.jointVelocityMax.push(reader.double());
            }

            continue;
          }

          break;
        }
        case 2: {
          if (tag === 17) {
            message.jointAccelerationMax.push(reader.double());

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.jointAccelerationMax.push(reader.double());
            }

            continue;
          }

          break;
        }
        case 3: {
          if (tag === 25) {
            message.jointTorqueMax.push(reader.double());

            continue;
          }

          if (tag === 26) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.jointTorqueMax.push(reader.double());
            }

            continue;
          }

          break;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.tcpLinearVelocityMax = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SafetyLimits {
    return {
      jointVelocityMax: globalThis.Array.isArray(object?.jointVelocityMax)
        ? object.jointVelocityMax.map((e: any) => globalThis.Number(e))
        : [],
      jointAccelerationMax: globalThis.Array.isArray(object?.jointAccelerationMax)
        ? object.jointAccelerationMax.map((e: any) => globalThis.Number(e))
        : [],
      jointTorqueMax: globalThis.Array.isArray(object?.jointTorqueMax)
        ? object.jointTorqueMax.map((e: any) => globalThis.Number(e))
        : [],
      tcpLinearVelocityMax: isSet(object.tcpLinearVelocityMax) ? globalThis.Number(object.tcpLinearVelocityMax) : 0,
    };
  },

  toJSON(message: SafetyLimits): unknown {
    const obj: any = {};
    if (message.jointVelocityMax?.length) {
      obj.jointVelocityMax = message.jointVelocityMax;
    }
    if (message.jointAccelerationMax?.length) {
      obj.jointAccelerationMax = message.jointAccelerationMax;
    }
    if (message.jointTorqueMax?.length) {
      obj.jointTorqueMax = message.jointTorqueMax;
    }
    if (message.tcpLinearVelocityMax !== 0) {
      obj.tcpLinearVelocityMax = message.tcpLinearVelocityMax;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SafetyLimits>, I>>(base?: I): SafetyLimits {
    return SafetyLimits.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SafetyLimits>, I>>(object: I): SafetyLimits {
    const message = createBaseSafetyLimits();
    message.jointVelocityMax = object.jointVelocityMax?.map((e) => e) || [];
    message.jointAccelerationMax = object.jointAccelerationMax?.map((e) => e) || [];
    message.jointTorqueMax = object.jointTorqueMax?.map((e) => e) || [];
    message.tcpLinearVelocityMax = object.tcpLinearVelocityMax ?? 0;
    return message;
  },
};

function createBaseSafetySession(): SafetySession {
  return { fullSpeed: undefined, slowSpeed: undefined };
}

export const SafetySession: MessageFns<SafetySession> = {
  encode(message: SafetySession, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fullSpeed !== undefined) {
      SafetyLimits.encode(message.fullSpeed, writer.uint32(10).fork()).join();
    }
    if (message.slowSpeed !== undefined) {
      SafetyLimits.encode(message.slowSpeed, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SafetySession {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSafetySession();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fullSpeed = SafetyLimits.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.slowSpeed = SafetyLimits.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SafetySession {
    return {
      fullSpeed: isSet(object.fullSpeed) ? SafetyLimits.fromJSON(object.fullSpeed) : undefined,
      slowSpeed: isSet(object.slowSpeed) ? SafetyLimits.fromJSON(object.slowSpeed) : undefined,
    };
  },

  toJSON(message: SafetySession): unknown {
    const obj: any = {};
    if (message.fullSpeed !== undefined) {
      obj.fullSpeed = SafetyLimits.toJSON(message.fullSpeed);
    }
    if (message.slowSpeed !== undefined) {
      obj.slowSpeed = SafetyLimits.toJSON(message.slowSpeed);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SafetySession>, I>>(base?: I): SafetySession {
    return SafetySession.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SafetySession>, I>>(object: I): SafetySession {
    const message = createBaseSafetySession();
    message.fullSpeed = (object.fullSpeed !== undefined && object.fullSpeed !== null)
      ? SafetyLimits.fromPartial(object.fullSpeed)
      : undefined;
    message.slowSpeed = (object.slowSpeed !== undefined && object.slowSpeed !== null)
      ? SafetyLimits.fromPartial(object.slowSpeed)
      : undefined;
    return message;
  },
};

function createBaseSpeedSlider(): SpeedSlider {
  return { value: 0 };
}

export const SpeedSlider: MessageFns<SpeedSlider> = {
  encode(message: SpeedSlider, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.value !== 0) {
      writer.uint32(9).double(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpeedSlider {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpeedSlider();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.value = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpeedSlider {
    return { value: isSet(object.value) ? globalThis.Number(object.value) : 0 };
  },

  toJSON(message: SpeedSlider): unknown {
    const obj: any = {};
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpeedSlider>, I>>(base?: I): SpeedSlider {
    return SpeedSlider.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpeedSlider>, I>>(object: I): SpeedSlider {
    const message = createBaseSpeedSlider();
    message.value = object.value ?? 0;
    return message;
  },
};

function createBaseSetReply(): SetReply {
  return { accepted: false, error: undefined };
}

export const SetReply: MessageFns<SetReply> = {
  encode(message: SetReply, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accepted !== false) {
      writer.uint32(8).bool(message.accepted);
    }
    if (message.error !== undefined) {
      writer.uint32(16).int32(message.error);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetReply {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetReply();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.accepted = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.error = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetReply {
    return {
      accepted: isSet(object.accepted) ? globalThis.Boolean(object.accepted) : false,
      error: isSet(object.error) ? tCErrorCodeFromJSON(object.error) : undefined,
    };
  },

  toJSON(message: SetReply): unknown {
    const obj: any = {};
    if (message.accepted !== false) {
      obj.accepted = message.accepted;
    }
    if (message.error !== undefined) {
      obj.error = tCErrorCodeToJSON(message.error);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetReply>, I>>(base?: I): SetReply {
    return SetReply.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetReply>, I>>(object: I): SetReply {
    const message = createBaseSetReply();
    message.accepted = object.accepted ?? false;
    message.error = object.error ?? undefined;
    return message;
  },
};

function createBaseControllerStateMsg(): ControllerStateMsg {
  return {
    state: 0,
    activePrimitiveId: undefined,
    activePrimitiveType: undefined,
    queueDepth: 0,
    speedScaling: 0,
    paused: false,
    stepCount: 0,
    errors: [],
    collisionStatus: undefined,
  };
}

export const ControllerStateMsg: MessageFns<ControllerStateMsg> = {
  encode(message: ControllerStateMsg, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.state !== 0) {
      writer.uint32(8).int32(message.state);
    }
    if (message.activePrimitiveId !== undefined) {
      writer.uint32(16).uint64(message.activePrimitiveId);
    }
    if (message.activePrimitiveType !== undefined) {
      writer.uint32(26).string(message.activePrimitiveType);
    }
    if (message.queueDepth !== 0) {
      writer.uint32(32).uint32(message.queueDepth);
    }
    if (message.speedScaling !== 0) {
      writer.uint32(45).float(message.speedScaling);
    }
    if (message.paused !== false) {
      writer.uint32(48).bool(message.paused);
    }
    if (message.stepCount !== 0) {
      writer.uint32(56).uint64(message.stepCount);
    }
    writer.uint32(66).fork();
    for (const v of message.errors) {
      writer.int32(v);
    }
    writer.join();
    if (message.collisionStatus !== undefined) {
      CollisionStatus.encode(message.collisionStatus, writer.uint32(74).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ControllerStateMsg {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseControllerStateMsg();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.state = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.activePrimitiveId = longToNumber(reader.uint64());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.activePrimitiveType = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.queueDepth = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 45) {
            break;
          }

          message.speedScaling = reader.float();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.paused = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.stepCount = longToNumber(reader.uint64());
          continue;
        }
        case 8: {
          if (tag === 64) {
            message.errors.push(reader.int32() as any);

            continue;
          }

          if (tag === 66) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.errors.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.collisionStatus = CollisionStatus.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ControllerStateMsg {
    return {
      state: isSet(object.state) ? tCStateFromJSON(object.state) : 0,
      activePrimitiveId: isSet(object.activePrimitiveId) ? globalThis.Number(object.activePrimitiveId) : undefined,
      activePrimitiveType: isSet(object.activePrimitiveType)
        ? globalThis.String(object.activePrimitiveType)
        : undefined,
      queueDepth: isSet(object.queueDepth) ? globalThis.Number(object.queueDepth) : 0,
      speedScaling: isSet(object.speedScaling) ? globalThis.Number(object.speedScaling) : 0,
      paused: isSet(object.paused) ? globalThis.Boolean(object.paused) : false,
      stepCount: isSet(object.stepCount) ? globalThis.Number(object.stepCount) : 0,
      errors: globalThis.Array.isArray(object?.errors) ? object.errors.map((e: any) => tCErrorCodeFromJSON(e)) : [],
      collisionStatus: isSet(object.collisionStatus) ? CollisionStatus.fromJSON(object.collisionStatus) : undefined,
    };
  },

  toJSON(message: ControllerStateMsg): unknown {
    const obj: any = {};
    if (message.state !== 0) {
      obj.state = tCStateToJSON(message.state);
    }
    if (message.activePrimitiveId !== undefined) {
      obj.activePrimitiveId = Math.round(message.activePrimitiveId);
    }
    if (message.activePrimitiveType !== undefined) {
      obj.activePrimitiveType = message.activePrimitiveType;
    }
    if (message.queueDepth !== 0) {
      obj.queueDepth = Math.round(message.queueDepth);
    }
    if (message.speedScaling !== 0) {
      obj.speedScaling = message.speedScaling;
    }
    if (message.paused !== false) {
      obj.paused = message.paused;
    }
    if (message.stepCount !== 0) {
      obj.stepCount = Math.round(message.stepCount);
    }
    if (message.errors?.length) {
      obj.errors = message.errors.map((e) => tCErrorCodeToJSON(e));
    }
    if (message.collisionStatus !== undefined) {
      obj.collisionStatus = CollisionStatus.toJSON(message.collisionStatus);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ControllerStateMsg>, I>>(base?: I): ControllerStateMsg {
    return ControllerStateMsg.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ControllerStateMsg>, I>>(object: I): ControllerStateMsg {
    const message = createBaseControllerStateMsg();
    message.state = object.state ?? 0;
    message.activePrimitiveId = object.activePrimitiveId ?? undefined;
    message.activePrimitiveType = object.activePrimitiveType ?? undefined;
    message.queueDepth = object.queueDepth ?? 0;
    message.speedScaling = object.speedScaling ?? 0;
    message.paused = object.paused ?? false;
    message.stepCount = object.stepCount ?? 0;
    message.errors = object.errors?.map((e) => e) || [];
    message.collisionStatus = (object.collisionStatus !== undefined && object.collisionStatus !== null)
      ? CollisionStatus.fromPartial(object.collisionStatus)
      : undefined;
    return message;
  },
};

function createBasePrimitiveEventMsg(): PrimitiveEventMsg {
  return { type: 0, primitiveId: undefined, error: undefined };
}

export const PrimitiveEventMsg: MessageFns<PrimitiveEventMsg> = {
  encode(message: PrimitiveEventMsg, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    if (message.primitiveId !== undefined) {
      writer.uint32(16).uint64(message.primitiveId);
    }
    if (message.error !== undefined) {
      writer.uint32(24).int32(message.error);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PrimitiveEventMsg {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePrimitiveEventMsg();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.primitiveId = longToNumber(reader.uint64());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.error = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PrimitiveEventMsg {
    return {
      type: isSet(object.type) ? primitiveEventTypeFromJSON(object.type) : 0,
      primitiveId: isSet(object.primitiveId) ? globalThis.Number(object.primitiveId) : undefined,
      error: isSet(object.error) ? tCErrorCodeFromJSON(object.error) : undefined,
    };
  },

  toJSON(message: PrimitiveEventMsg): unknown {
    const obj: any = {};
    if (message.type !== 0) {
      obj.type = primitiveEventTypeToJSON(message.type);
    }
    if (message.primitiveId !== undefined) {
      obj.primitiveId = Math.round(message.primitiveId);
    }
    if (message.error !== undefined) {
      obj.error = tCErrorCodeToJSON(message.error);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PrimitiveEventMsg>, I>>(base?: I): PrimitiveEventMsg {
    return PrimitiveEventMsg.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PrimitiveEventMsg>, I>>(object: I): PrimitiveEventMsg {
    const message = createBasePrimitiveEventMsg();
    message.type = object.type ?? 0;
    message.primitiveId = object.primitiveId ?? undefined;
    message.error = object.error ?? undefined;
    return message;
  },
};

function createBaseCommandedStateMsg(): CommandedStateMsg {
  return {
    tick: 0,
    timestamp: undefined,
    positions: [],
    velocities: [],
    accelerations: [],
    suppressed: false,
    overrun: false,
    targetFresh: undefined,
    targetWriteSeq: undefined,
    servojTarget: undefined,
    servolTarget: undefined,
  };
}

export const CommandedStateMsg: MessageFns<CommandedStateMsg> = {
  encode(message: CommandedStateMsg, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tick !== 0) {
      writer.uint32(8).uint64(message.tick);
    }
    if (message.timestamp !== undefined) {
      Timestamp.encode(toTimestamp(message.timestamp), writer.uint32(18).fork()).join();
    }
    writer.uint32(26).fork();
    for (const v of message.positions) {
      writer.double(v);
    }
    writer.join();
    writer.uint32(34).fork();
    for (const v of message.velocities) {
      writer.double(v);
    }
    writer.join();
    writer.uint32(42).fork();
    for (const v of message.accelerations) {
      writer.double(v);
    }
    writer.join();
    if (message.suppressed !== false) {
      writer.uint32(48).bool(message.suppressed);
    }
    if (message.overrun !== false) {
      writer.uint32(56).bool(message.overrun);
    }
    if (message.targetFresh !== undefined) {
      writer.uint32(72).bool(message.targetFresh);
    }
    if (message.targetWriteSeq !== undefined) {
      writer.uint32(96).uint64(message.targetWriteSeq);
    }
    if (message.servojTarget !== undefined) {
      ServoJTarget.encode(message.servojTarget, writer.uint32(82).fork()).join();
    }
    if (message.servolTarget !== undefined) {
      ServoLTarget.encode(message.servolTarget, writer.uint32(90).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CommandedStateMsg {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCommandedStateMsg();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.tick = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.timestamp = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag === 25) {
            message.positions.push(reader.double());

            continue;
          }

          if (tag === 26) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.positions.push(reader.double());
            }

            continue;
          }

          break;
        }
        case 4: {
          if (tag === 33) {
            message.velocities.push(reader.double());

            continue;
          }

          if (tag === 34) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.velocities.push(reader.double());
            }

            continue;
          }

          break;
        }
        case 5: {
          if (tag === 41) {
            message.accelerations.push(reader.double());

            continue;
          }

          if (tag === 42) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.accelerations.push(reader.double());
            }

            continue;
          }

          break;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.suppressed = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.overrun = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.targetFresh = reader.bool();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.targetWriteSeq = longToNumber(reader.uint64());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.servojTarget = ServoJTarget.decode(reader, reader.uint32());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.servolTarget = ServoLTarget.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CommandedStateMsg {
    return {
      tick: isSet(object.tick) ? globalThis.Number(object.tick) : 0,
      timestamp: isSet(object.timestamp) ? fromJsonTimestamp(object.timestamp) : undefined,
      positions: globalThis.Array.isArray(object?.positions)
        ? object.positions.map((e: any) => globalThis.Number(e))
        : [],
      velocities: globalThis.Array.isArray(object?.velocities)
        ? object.velocities.map((e: any) => globalThis.Number(e))
        : [],
      accelerations: globalThis.Array.isArray(object?.accelerations)
        ? object.accelerations.map((e: any) => globalThis.Number(e))
        : [],
      suppressed: isSet(object.suppressed) ? globalThis.Boolean(object.suppressed) : false,
      overrun: isSet(object.overrun) ? globalThis.Boolean(object.overrun) : false,
      targetFresh: isSet(object.targetFresh) ? globalThis.Boolean(object.targetFresh) : undefined,
      targetWriteSeq: isSet(object.targetWriteSeq) ? globalThis.Number(object.targetWriteSeq) : undefined,
      servojTarget: isSet(object.servojTarget) ? ServoJTarget.fromJSON(object.servojTarget) : undefined,
      servolTarget: isSet(object.servolTarget) ? ServoLTarget.fromJSON(object.servolTarget) : undefined,
    };
  },

  toJSON(message: CommandedStateMsg): unknown {
    const obj: any = {};
    if (message.tick !== 0) {
      obj.tick = Math.round(message.tick);
    }
    if (message.timestamp !== undefined) {
      obj.timestamp = message.timestamp.toISOString();
    }
    if (message.positions?.length) {
      obj.positions = message.positions;
    }
    if (message.velocities?.length) {
      obj.velocities = message.velocities;
    }
    if (message.accelerations?.length) {
      obj.accelerations = message.accelerations;
    }
    if (message.suppressed !== false) {
      obj.suppressed = message.suppressed;
    }
    if (message.overrun !== false) {
      obj.overrun = message.overrun;
    }
    if (message.targetFresh !== undefined) {
      obj.targetFresh = message.targetFresh;
    }
    if (message.targetWriteSeq !== undefined) {
      obj.targetWriteSeq = Math.round(message.targetWriteSeq);
    }
    if (message.servojTarget !== undefined) {
      obj.servojTarget = ServoJTarget.toJSON(message.servojTarget);
    }
    if (message.servolTarget !== undefined) {
      obj.servolTarget = ServoLTarget.toJSON(message.servolTarget);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CommandedStateMsg>, I>>(base?: I): CommandedStateMsg {
    return CommandedStateMsg.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CommandedStateMsg>, I>>(object: I): CommandedStateMsg {
    const message = createBaseCommandedStateMsg();
    message.tick = object.tick ?? 0;
    message.timestamp = object.timestamp ?? undefined;
    message.positions = object.positions?.map((e) => e) || [];
    message.velocities = object.velocities?.map((e) => e) || [];
    message.accelerations = object.accelerations?.map((e) => e) || [];
    message.suppressed = object.suppressed ?? false;
    message.overrun = object.overrun ?? false;
    message.targetFresh = object.targetFresh ?? undefined;
    message.targetWriteSeq = object.targetWriteSeq ?? undefined;
    message.servojTarget = (object.servojTarget !== undefined && object.servojTarget !== null)
      ? ServoJTarget.fromPartial(object.servojTarget)
      : undefined;
    message.servolTarget = (object.servolTarget !== undefined && object.servolTarget !== null)
      ? ServoLTarget.fromPartial(object.servolTarget)
      : undefined;
    return message;
  },
};

function createBaseServoJTarget(): ServoJTarget {
  return { targetJoints: [], targetJointVelocities: [] };
}

export const ServoJTarget: MessageFns<ServoJTarget> = {
  encode(message: ServoJTarget, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    writer.uint32(10).fork();
    for (const v of message.targetJoints) {
      writer.double(v);
    }
    writer.join();
    writer.uint32(18).fork();
    for (const v of message.targetJointVelocities) {
      writer.double(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServoJTarget {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServoJTarget();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag === 9) {
            message.targetJoints.push(reader.double());

            continue;
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.targetJoints.push(reader.double());
            }

            continue;
          }

          break;
        }
        case 2: {
          if (tag === 17) {
            message.targetJointVelocities.push(reader.double());

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.targetJointVelocities.push(reader.double());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServoJTarget {
    return {
      targetJoints: globalThis.Array.isArray(object?.targetJoints)
        ? object.targetJoints.map((e: any) => globalThis.Number(e))
        : [],
      targetJointVelocities: globalThis.Array.isArray(object?.targetJointVelocities)
        ? object.targetJointVelocities.map((e: any) => globalThis.Number(e))
        : [],
    };
  },

  toJSON(message: ServoJTarget): unknown {
    const obj: any = {};
    if (message.targetJoints?.length) {
      obj.targetJoints = message.targetJoints;
    }
    if (message.targetJointVelocities?.length) {
      obj.targetJointVelocities = message.targetJointVelocities;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServoJTarget>, I>>(base?: I): ServoJTarget {
    return ServoJTarget.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServoJTarget>, I>>(object: I): ServoJTarget {
    const message = createBaseServoJTarget();
    message.targetJoints = object.targetJoints?.map((e) => e) || [];
    message.targetJointVelocities = object.targetJointVelocities?.map((e) => e) || [];
    return message;
  },
};

function createBaseServoLTarget(): ServoLTarget {
  return { poseStream: undefined, twistStream: undefined };
}

export const ServoLTarget: MessageFns<ServoLTarget> = {
  encode(message: ServoLTarget, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.poseStream !== undefined) {
      Pose.encode(message.poseStream, writer.uint32(10).fork()).join();
    }
    if (message.twistStream !== undefined) {
      CartesianVelocity.encode(message.twistStream, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServoLTarget {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServoLTarget();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.poseStream = Pose.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.twistStream = CartesianVelocity.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServoLTarget {
    return {
      poseStream: isSet(object.poseStream) ? Pose.fromJSON(object.poseStream) : undefined,
      twistStream: isSet(object.twistStream) ? CartesianVelocity.fromJSON(object.twistStream) : undefined,
    };
  },

  toJSON(message: ServoLTarget): unknown {
    const obj: any = {};
    if (message.poseStream !== undefined) {
      obj.poseStream = Pose.toJSON(message.poseStream);
    }
    if (message.twistStream !== undefined) {
      obj.twistStream = CartesianVelocity.toJSON(message.twistStream);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServoLTarget>, I>>(base?: I): ServoLTarget {
    return ServoLTarget.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServoLTarget>, I>>(object: I): ServoLTarget {
    const message = createBaseServoLTarget();
    message.poseStream = (object.poseStream !== undefined && object.poseStream !== null)
      ? Pose.fromPartial(object.poseStream)
      : undefined;
    message.twistStream = (object.twistStream !== undefined && object.twistStream !== null)
      ? CartesianVelocity.fromPartial(object.twistStream)
      : undefined;
    return message;
  },
};

function createBaseTCEventMsg(): TCEventMsg {
  return {
    code: 0,
    severity: 0,
    message: "",
    intA: 0,
    intB: 0,
    intC: 0,
    floatA: 0,
    seq: 0,
    droppedEvents: 0,
    occurredAtUs: 0,
    producerEpoch: 0,
  };
}

export const TCEventMsg: MessageFns<TCEventMsg> = {
  encode(message: TCEventMsg, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.code !== 0) {
      writer.uint32(8).int32(message.code);
    }
    if (message.severity !== 0) {
      writer.uint32(16).int32(message.severity);
    }
    if (message.message !== "") {
      writer.uint32(26).string(message.message);
    }
    if (message.intA !== 0) {
      writer.uint32(32).uint32(message.intA);
    }
    if (message.intB !== 0) {
      writer.uint32(40).uint32(message.intB);
    }
    if (message.intC !== 0) {
      writer.uint32(48).uint32(message.intC);
    }
    if (message.floatA !== 0) {
      writer.uint32(61).float(message.floatA);
    }
    if (message.seq !== 0) {
      writer.uint32(64).uint64(message.seq);
    }
    if (message.droppedEvents !== 0) {
      writer.uint32(72).uint64(message.droppedEvents);
    }
    if (message.occurredAtUs !== 0) {
      writer.uint32(80).uint64(message.occurredAtUs);
    }
    if (message.producerEpoch !== 0) {
      writer.uint32(88).uint64(message.producerEpoch);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TCEventMsg {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTCEventMsg();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.code = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.severity = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.message = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.intA = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.intB = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.intC = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 61) {
            break;
          }

          message.floatA = reader.float();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.seq = longToNumber(reader.uint64());
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.droppedEvents = longToNumber(reader.uint64());
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.occurredAtUs = longToNumber(reader.uint64());
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.producerEpoch = longToNumber(reader.uint64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TCEventMsg {
    return {
      code: isSet(object.code) ? tCEventCodeFromJSON(object.code) : 0,
      severity: isSet(object.severity) ? tCSeverityFromJSON(object.severity) : 0,
      message: isSet(object.message) ? globalThis.String(object.message) : "",
      intA: isSet(object.intA) ? globalThis.Number(object.intA) : 0,
      intB: isSet(object.intB) ? globalThis.Number(object.intB) : 0,
      intC: isSet(object.intC) ? globalThis.Number(object.intC) : 0,
      floatA: isSet(object.floatA) ? globalThis.Number(object.floatA) : 0,
      seq: isSet(object.seq) ? globalThis.Number(object.seq) : 0,
      droppedEvents: isSet(object.droppedEvents) ? globalThis.Number(object.droppedEvents) : 0,
      occurredAtUs: isSet(object.occurredAtUs) ? globalThis.Number(object.occurredAtUs) : 0,
      producerEpoch: isSet(object.producerEpoch) ? globalThis.Number(object.producerEpoch) : 0,
    };
  },

  toJSON(message: TCEventMsg): unknown {
    const obj: any = {};
    if (message.code !== 0) {
      obj.code = tCEventCodeToJSON(message.code);
    }
    if (message.severity !== 0) {
      obj.severity = tCSeverityToJSON(message.severity);
    }
    if (message.message !== "") {
      obj.message = message.message;
    }
    if (message.intA !== 0) {
      obj.intA = Math.round(message.intA);
    }
    if (message.intB !== 0) {
      obj.intB = Math.round(message.intB);
    }
    if (message.intC !== 0) {
      obj.intC = Math.round(message.intC);
    }
    if (message.floatA !== 0) {
      obj.floatA = message.floatA;
    }
    if (message.seq !== 0) {
      obj.seq = Math.round(message.seq);
    }
    if (message.droppedEvents !== 0) {
      obj.droppedEvents = Math.round(message.droppedEvents);
    }
    if (message.occurredAtUs !== 0) {
      obj.occurredAtUs = Math.round(message.occurredAtUs);
    }
    if (message.producerEpoch !== 0) {
      obj.producerEpoch = Math.round(message.producerEpoch);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TCEventMsg>, I>>(base?: I): TCEventMsg {
    return TCEventMsg.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TCEventMsg>, I>>(object: I): TCEventMsg {
    const message = createBaseTCEventMsg();
    message.code = object.code ?? 0;
    message.severity = object.severity ?? 0;
    message.message = object.message ?? "";
    message.intA = object.intA ?? 0;
    message.intB = object.intB ?? 0;
    message.intC = object.intC ?? 0;
    message.floatA = object.floatA ?? 0;
    message.seq = object.seq ?? 0;
    message.droppedEvents = object.droppedEvents ?? 0;
    message.occurredAtUs = object.occurredAtUs ?? 0;
    message.producerEpoch = object.producerEpoch ?? 0;
    return message;
  },
};

function createBaseCollisionConfig(): CollisionConfig {
  return { collisionMargin: 0, penetrationBypass: false, disabledPairs: [] };
}

export const CollisionConfig: MessageFns<CollisionConfig> = {
  encode(message: CollisionConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.collisionMargin !== 0) {
      writer.uint32(9).double(message.collisionMargin);
    }
    if (message.penetrationBypass !== false) {
      writer.uint32(16).bool(message.penetrationBypass);
    }
    for (const v of message.disabledPairs) {
      DisabledCollisionPair.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CollisionConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCollisionConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.collisionMargin = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.penetrationBypass = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.disabledPairs.push(DisabledCollisionPair.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CollisionConfig {
    return {
      collisionMargin: isSet(object.collisionMargin) ? globalThis.Number(object.collisionMargin) : 0,
      penetrationBypass: isSet(object.penetrationBypass) ? globalThis.Boolean(object.penetrationBypass) : false,
      disabledPairs: globalThis.Array.isArray(object?.disabledPairs)
        ? object.disabledPairs.map((e: any) => DisabledCollisionPair.fromJSON(e))
        : [],
    };
  },

  toJSON(message: CollisionConfig): unknown {
    const obj: any = {};
    if (message.collisionMargin !== 0) {
      obj.collisionMargin = message.collisionMargin;
    }
    if (message.penetrationBypass !== false) {
      obj.penetrationBypass = message.penetrationBypass;
    }
    if (message.disabledPairs?.length) {
      obj.disabledPairs = message.disabledPairs.map((e) => DisabledCollisionPair.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CollisionConfig>, I>>(base?: I): CollisionConfig {
    return CollisionConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CollisionConfig>, I>>(object: I): CollisionConfig {
    const message = createBaseCollisionConfig();
    message.collisionMargin = object.collisionMargin ?? 0;
    message.penetrationBypass = object.penetrationBypass ?? false;
    message.disabledPairs = object.disabledPairs?.map((e) => DisabledCollisionPair.fromPartial(e)) || [];
    return message;
  },
};

function createBaseDisabledCollisionPair(): DisabledCollisionPair {
  return { linkA: "", linkB: "" };
}

export const DisabledCollisionPair: MessageFns<DisabledCollisionPair> = {
  encode(message: DisabledCollisionPair, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.linkA !== "") {
      writer.uint32(10).string(message.linkA);
    }
    if (message.linkB !== "") {
      writer.uint32(18).string(message.linkB);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DisabledCollisionPair {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDisabledCollisionPair();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.linkA = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.linkB = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DisabledCollisionPair {
    return {
      linkA: isSet(object.linkA) ? globalThis.String(object.linkA) : "",
      linkB: isSet(object.linkB) ? globalThis.String(object.linkB) : "",
    };
  },

  toJSON(message: DisabledCollisionPair): unknown {
    const obj: any = {};
    if (message.linkA !== "") {
      obj.linkA = message.linkA;
    }
    if (message.linkB !== "") {
      obj.linkB = message.linkB;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DisabledCollisionPair>, I>>(base?: I): DisabledCollisionPair {
    return DisabledCollisionPair.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DisabledCollisionPair>, I>>(object: I): DisabledCollisionPair {
    const message = createBaseDisabledCollisionPair();
    message.linkA = object.linkA ?? "";
    message.linkB = object.linkB ?? "";
    return message;
  },
};

function createBaseCollisionBody(): CollisionBody {
  return { label: "", mount: undefined };
}

export const CollisionBody: MessageFns<CollisionBody> = {
  encode(message: CollisionBody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.label !== "") {
      writer.uint32(10).string(message.label);
    }
    if (message.mount !== undefined) {
      MountOffset.encode(message.mount, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CollisionBody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCollisionBody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.label = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.mount = MountOffset.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CollisionBody {
    return {
      label: isSet(object.label) ? globalThis.String(object.label) : "",
      mount: isSet(object.mount) ? MountOffset.fromJSON(object.mount) : undefined,
    };
  },

  toJSON(message: CollisionBody): unknown {
    const obj: any = {};
    if (message.label !== "") {
      obj.label = message.label;
    }
    if (message.mount !== undefined) {
      obj.mount = MountOffset.toJSON(message.mount);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CollisionBody>, I>>(base?: I): CollisionBody {
    return CollisionBody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CollisionBody>, I>>(object: I): CollisionBody {
    const message = createBaseCollisionBody();
    message.label = object.label ?? "";
    message.mount = (object.mount !== undefined && object.mount !== null)
      ? MountOffset.fromPartial(object.mount)
      : undefined;
    return message;
  },
};

function createBaseMountOffset(): MountOffset {
  return { tx: 0, ty: 0, tz: 0, rx: 0, ry: 0, rz: 0, rw: 0 };
}

export const MountOffset: MessageFns<MountOffset> = {
  encode(message: MountOffset, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tx !== 0) {
      writer.uint32(9).double(message.tx);
    }
    if (message.ty !== 0) {
      writer.uint32(17).double(message.ty);
    }
    if (message.tz !== 0) {
      writer.uint32(25).double(message.tz);
    }
    if (message.rx !== 0) {
      writer.uint32(33).double(message.rx);
    }
    if (message.ry !== 0) {
      writer.uint32(41).double(message.ry);
    }
    if (message.rz !== 0) {
      writer.uint32(49).double(message.rz);
    }
    if (message.rw !== 0) {
      writer.uint32(57).double(message.rw);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MountOffset {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMountOffset();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.tx = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.ty = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.tz = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.rx = reader.double();
          continue;
        }
        case 5: {
          if (tag !== 41) {
            break;
          }

          message.ry = reader.double();
          continue;
        }
        case 6: {
          if (tag !== 49) {
            break;
          }

          message.rz = reader.double();
          continue;
        }
        case 7: {
          if (tag !== 57) {
            break;
          }

          message.rw = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MountOffset {
    return {
      tx: isSet(object.tx) ? globalThis.Number(object.tx) : 0,
      ty: isSet(object.ty) ? globalThis.Number(object.ty) : 0,
      tz: isSet(object.tz) ? globalThis.Number(object.tz) : 0,
      rx: isSet(object.rx) ? globalThis.Number(object.rx) : 0,
      ry: isSet(object.ry) ? globalThis.Number(object.ry) : 0,
      rz: isSet(object.rz) ? globalThis.Number(object.rz) : 0,
      rw: isSet(object.rw) ? globalThis.Number(object.rw) : 0,
    };
  },

  toJSON(message: MountOffset): unknown {
    const obj: any = {};
    if (message.tx !== 0) {
      obj.tx = message.tx;
    }
    if (message.ty !== 0) {
      obj.ty = message.ty;
    }
    if (message.tz !== 0) {
      obj.tz = message.tz;
    }
    if (message.rx !== 0) {
      obj.rx = message.rx;
    }
    if (message.ry !== 0) {
      obj.ry = message.ry;
    }
    if (message.rz !== 0) {
      obj.rz = message.rz;
    }
    if (message.rw !== 0) {
      obj.rw = message.rw;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MountOffset>, I>>(base?: I): MountOffset {
    return MountOffset.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MountOffset>, I>>(object: I): MountOffset {
    const message = createBaseMountOffset();
    message.tx = object.tx ?? 0;
    message.ty = object.ty ?? 0;
    message.tz = object.tz ?? 0;
    message.rx = object.rx ?? 0;
    message.ry = object.ry ?? 0;
    message.rz = object.rz ?? 0;
    message.rw = object.rw ?? 0;
    return message;
  },
};

function createBaseCollisionEquipment(): CollisionEquipment {
  return { bodies: [] };
}

export const CollisionEquipment: MessageFns<CollisionEquipment> = {
  encode(message: CollisionEquipment, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.bodies) {
      CollisionBody.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CollisionEquipment {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCollisionEquipment();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.bodies.push(CollisionBody.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CollisionEquipment {
    return {
      bodies: globalThis.Array.isArray(object?.bodies) ? object.bodies.map((e: any) => CollisionBody.fromJSON(e)) : [],
    };
  },

  toJSON(message: CollisionEquipment): unknown {
    const obj: any = {};
    if (message.bodies?.length) {
      obj.bodies = message.bodies.map((e) => CollisionBody.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CollisionEquipment>, I>>(base?: I): CollisionEquipment {
    return CollisionEquipment.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CollisionEquipment>, I>>(object: I): CollisionEquipment {
    const message = createBaseCollisionEquipment();
    message.bodies = object.bodies?.map((e) => CollisionBody.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCollisionStatus(): CollisionStatus {
  return { minDistance: 0, closestLinkA: 0, closestLinkB: 0, collisionBinding: false, rCollision: 0, zone: 0 };
}

export const CollisionStatus: MessageFns<CollisionStatus> = {
  encode(message: CollisionStatus, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.minDistance !== 0) {
      writer.uint32(9).double(message.minDistance);
    }
    if (message.closestLinkA !== 0) {
      writer.uint32(16).int32(message.closestLinkA);
    }
    if (message.closestLinkB !== 0) {
      writer.uint32(24).int32(message.closestLinkB);
    }
    if (message.collisionBinding !== false) {
      writer.uint32(32).bool(message.collisionBinding);
    }
    if (message.rCollision !== 0) {
      writer.uint32(41).double(message.rCollision);
    }
    if (message.zone !== 0) {
      writer.uint32(48).int32(message.zone);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CollisionStatus {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCollisionStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.minDistance = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.closestLinkA = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.closestLinkB = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.collisionBinding = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 41) {
            break;
          }

          message.rCollision = reader.double();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.zone = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CollisionStatus {
    return {
      minDistance: isSet(object.minDistance) ? globalThis.Number(object.minDistance) : 0,
      closestLinkA: isSet(object.closestLinkA) ? globalThis.Number(object.closestLinkA) : 0,
      closestLinkB: isSet(object.closestLinkB) ? globalThis.Number(object.closestLinkB) : 0,
      collisionBinding: isSet(object.collisionBinding) ? globalThis.Boolean(object.collisionBinding) : false,
      rCollision: isSet(object.rCollision) ? globalThis.Number(object.rCollision) : 0,
      zone: isSet(object.zone) ? collisionZoneFromJSON(object.zone) : 0,
    };
  },

  toJSON(message: CollisionStatus): unknown {
    const obj: any = {};
    if (message.minDistance !== 0) {
      obj.minDistance = message.minDistance;
    }
    if (message.closestLinkA !== 0) {
      obj.closestLinkA = Math.round(message.closestLinkA);
    }
    if (message.closestLinkB !== 0) {
      obj.closestLinkB = Math.round(message.closestLinkB);
    }
    if (message.collisionBinding !== false) {
      obj.collisionBinding = message.collisionBinding;
    }
    if (message.rCollision !== 0) {
      obj.rCollision = message.rCollision;
    }
    if (message.zone !== 0) {
      obj.zone = collisionZoneToJSON(message.zone);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CollisionStatus>, I>>(base?: I): CollisionStatus {
    return CollisionStatus.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CollisionStatus>, I>>(object: I): CollisionStatus {
    const message = createBaseCollisionStatus();
    message.minDistance = object.minDistance ?? 0;
    message.closestLinkA = object.closestLinkA ?? 0;
    message.closestLinkB = object.closestLinkB ?? 0;
    message.collisionBinding = object.collisionBinding ?? false;
    message.rCollision = object.rCollision ?? 0;
    message.zone = object.zone ?? 0;
    return message;
  },
};

/** @language: cpp */
export interface TrajectoryControllerService {
  Enqueue(request: Primitive): Promise<EnqueueReply>;
  GetJogDirections(request: GetJogDirectionsRequest): Promise<GetJogDirectionsReply>;
  SetSafetySession(request: SafetySession): Promise<SetReply>;
  SetSpeedSlider(request: SpeedSlider): Promise<SetReply>;
  Pause(request: Empty): Promise<ControllerStateMsg>;
  Resume(request: Empty): Promise<ControllerStateMsg>;
  ClearQueue(request: Empty): Promise<ControllerStateMsg>;
  Stop(request: Empty): Promise<ControllerStateMsg>;
  FastStop(request: Empty): Promise<ControllerStateMsg>;
  ClearError(request: Empty): Promise<ControllerStateMsg>;
}

export const TrajectoryControllerServiceServiceName = "trajectorycontroller.TrajectoryControllerService";
export class TrajectoryControllerServiceClientImpl implements TrajectoryControllerService {
  private readonly rpc: Rpc;
  private readonly service: string;
  constructor(rpc: Rpc, opts?: { service?: string }) {
    this.service = opts?.service || TrajectoryControllerServiceServiceName;
    this.rpc = rpc;
    this.Enqueue = this.Enqueue.bind(this);
    this.GetJogDirections = this.GetJogDirections.bind(this);
    this.SetSafetySession = this.SetSafetySession.bind(this);
    this.SetSpeedSlider = this.SetSpeedSlider.bind(this);
    this.Pause = this.Pause.bind(this);
    this.Resume = this.Resume.bind(this);
    this.ClearQueue = this.ClearQueue.bind(this);
    this.Stop = this.Stop.bind(this);
    this.FastStop = this.FastStop.bind(this);
    this.ClearError = this.ClearError.bind(this);
  }
  Enqueue(request: Primitive): Promise<EnqueueReply> {
    const data = Primitive.encode(request).finish();
    const promise = this.rpc.request(this.service, "Enqueue", data);
    return promise.then((data) => EnqueueReply.decode(new BinaryReader(data)));
  }

  GetJogDirections(request: GetJogDirectionsRequest): Promise<GetJogDirectionsReply> {
    const data = GetJogDirectionsRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetJogDirections", data);
    return promise.then((data) => GetJogDirectionsReply.decode(new BinaryReader(data)));
  }

  SetSafetySession(request: SafetySession): Promise<SetReply> {
    const data = SafetySession.encode(request).finish();
    const promise = this.rpc.request(this.service, "SetSafetySession", data);
    return promise.then((data) => SetReply.decode(new BinaryReader(data)));
  }

  SetSpeedSlider(request: SpeedSlider): Promise<SetReply> {
    const data = SpeedSlider.encode(request).finish();
    const promise = this.rpc.request(this.service, "SetSpeedSlider", data);
    return promise.then((data) => SetReply.decode(new BinaryReader(data)));
  }

  Pause(request: Empty): Promise<ControllerStateMsg> {
    const data = Empty.encode(request).finish();
    const promise = this.rpc.request(this.service, "Pause", data);
    return promise.then((data) => ControllerStateMsg.decode(new BinaryReader(data)));
  }

  Resume(request: Empty): Promise<ControllerStateMsg> {
    const data = Empty.encode(request).finish();
    const promise = this.rpc.request(this.service, "Resume", data);
    return promise.then((data) => ControllerStateMsg.decode(new BinaryReader(data)));
  }

  ClearQueue(request: Empty): Promise<ControllerStateMsg> {
    const data = Empty.encode(request).finish();
    const promise = this.rpc.request(this.service, "ClearQueue", data);
    return promise.then((data) => ControllerStateMsg.decode(new BinaryReader(data)));
  }

  Stop(request: Empty): Promise<ControllerStateMsg> {
    const data = Empty.encode(request).finish();
    const promise = this.rpc.request(this.service, "Stop", data);
    return promise.then((data) => ControllerStateMsg.decode(new BinaryReader(data)));
  }

  FastStop(request: Empty): Promise<ControllerStateMsg> {
    const data = Empty.encode(request).finish();
    const promise = this.rpc.request(this.service, "FastStop", data);
    return promise.then((data) => ControllerStateMsg.decode(new BinaryReader(data)));
  }

  ClearError(request: Empty): Promise<ControllerStateMsg> {
    const data = Empty.encode(request).finish();
    const promise = this.rpc.request(this.service, "ClearError", data);
    return promise.then((data) => ControllerStateMsg.decode(new BinaryReader(data)));
  }
}

/** @language: cpp */
export interface TrajectoryControllerTopics {
  ControllerState(request: ControllerStateMsg): Promise<Empty>;
  PrimitiveEvent(request: PrimitiveEventMsg): Promise<Empty>;
  CommandedState(request: CommandedStateMsg): Promise<Empty>;
  TCEvent(request: TCEventMsg): Promise<Empty>;
}

export const TrajectoryControllerTopicsServiceName = "trajectorycontroller.TrajectoryControllerTopics";
export class TrajectoryControllerTopicsClientImpl implements TrajectoryControllerTopics {
  private readonly rpc: Rpc;
  private readonly service: string;
  constructor(rpc: Rpc, opts?: { service?: string }) {
    this.service = opts?.service || TrajectoryControllerTopicsServiceName;
    this.rpc = rpc;
    this.ControllerState = this.ControllerState.bind(this);
    this.PrimitiveEvent = this.PrimitiveEvent.bind(this);
    this.CommandedState = this.CommandedState.bind(this);
    this.TCEvent = this.TCEvent.bind(this);
  }
  ControllerState(request: ControllerStateMsg): Promise<Empty> {
    const data = ControllerStateMsg.encode(request).finish();
    const promise = this.rpc.request(this.service, "ControllerState", data);
    return promise.then((data) => Empty.decode(new BinaryReader(data)));
  }

  PrimitiveEvent(request: PrimitiveEventMsg): Promise<Empty> {
    const data = PrimitiveEventMsg.encode(request).finish();
    const promise = this.rpc.request(this.service, "PrimitiveEvent", data);
    return promise.then((data) => Empty.decode(new BinaryReader(data)));
  }

  CommandedState(request: CommandedStateMsg): Promise<Empty> {
    const data = CommandedStateMsg.encode(request).finish();
    const promise = this.rpc.request(this.service, "CommandedState", data);
    return promise.then((data) => Empty.decode(new BinaryReader(data)));
  }

  TCEvent(request: TCEventMsg): Promise<Empty> {
    const data = TCEventMsg.encode(request).finish();
    const promise = this.rpc.request(this.service, "TCEvent", data);
    return promise.then((data) => Empty.decode(new BinaryReader(data)));
  }
}

/** @language: cpp */
export interface TrajectoryControllerSinks {
  WriteServoJ(request: ServoJTarget): Promise<Empty>;
  WriteServoL(request: ServoLTarget): Promise<Empty>;
}

export const TrajectoryControllerSinksServiceName = "trajectorycontroller.TrajectoryControllerSinks";
export class TrajectoryControllerSinksClientImpl implements TrajectoryControllerSinks {
  private readonly rpc: Rpc;
  private readonly service: string;
  constructor(rpc: Rpc, opts?: { service?: string }) {
    this.service = opts?.service || TrajectoryControllerSinksServiceName;
    this.rpc = rpc;
    this.WriteServoJ = this.WriteServoJ.bind(this);
    this.WriteServoL = this.WriteServoL.bind(this);
  }
  WriteServoJ(request: ServoJTarget): Promise<Empty> {
    const data = ServoJTarget.encode(request).finish();
    const promise = this.rpc.request(this.service, "WriteServoJ", data);
    return promise.then((data) => Empty.decode(new BinaryReader(data)));
  }

  WriteServoL(request: ServoLTarget): Promise<Empty> {
    const data = ServoLTarget.encode(request).finish();
    const promise = this.rpc.request(this.service, "WriteServoL", data);
    return promise.then((data) => Empty.decode(new BinaryReader(data)));
  }
}

interface Rpc {
  request(service: string, method: string, data: Uint8Array): Promise<Uint8Array>;
}

type ProtoMetaMessageOptions = {
  options?: { [key: string]: any };
  fields?: { [key: string]: { [key: string]: any } };
  oneof?: { [key: string]: { [key: string]: any } };
  nested?: { [key: string]: ProtoMetaMessageOptions };
};

export interface ProtoMetadata {
  fileDescriptor: FileDescriptorProto1;
  references: { [key: string]: any };
  dependencies?: ProtoMetadata[];
  options?: {
    options?: { [key: string]: any };
    services?: {
      [key: string]: { options?: { [key: string]: any }; methods?: { [key: string]: { [key: string]: any } } };
    };
    messages?: { [key: string]: ProtoMetaMessageOptions };
    enums?: { [key: string]: { options?: { [key: string]: any }; values?: { [key: string]: { [key: string]: any } } } };
  };
}

export const protoMetadata: ProtoMetadata = {
  fileDescriptor: {
    "name": "messenger/trajectory_controller_service.proto",
    "package": "trajectorycontroller",
    "dependency": [
      "google/protobuf/empty.proto",
      "google/protobuf/timestamp.proto",
      "messenger/geometry.proto",
      "messenger/joints.proto",
    ],
    "publicDependency": [],
    "weakDependency": [],
    "messageType": [{
      "name": "CartesianVelocity",
      "field": [{
        "name": "linear",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".geometry.Vector3",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "linear",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "angular",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".geometry.Vector3",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "angular",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ServoJ",
      "field": [{
        "name": "k_p",
        "number": 1,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "kP",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "command_timeout_ms",
        "number": 2,
        "label": 1,
        "type": 13,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "commandTimeoutMs",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "ramp_in_duration_ms",
        "number": 3,
        "label": 1,
        "type": 13,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "rampInDurationMs",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "position_smoothing_time_constant_ms",
        "number": 4,
        "label": 1,
        "type": 13,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "positionSmoothingTimeConstantMs",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ServoL",
      "field": [{
        "name": "k_p",
        "number": 1,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "kP",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "command_timeout_ms",
        "number": 2,
        "label": 1,
        "type": 13,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "commandTimeoutMs",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "ramp_in_duration_ms",
        "number": 3,
        "label": 1,
        "type": 13,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "rampInDurationMs",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "reference",
        "number": 4,
        "label": 1,
        "type": 11,
        "typeName": ".trajectorycontroller.Frame",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "reference",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "commanded_frame",
        "number": 5,
        "label": 1,
        "type": 11,
        "typeName": ".trajectorycontroller.Frame",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "commandedFrame",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "velocity_expressed_in",
        "number": 6,
        "label": 1,
        "type": 11,
        "typeName": ".trajectorycontroller.Orientation",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "velocityExpressedIn",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "motion_scaling_limits",
        "number": 7,
        "label": 1,
        "type": 11,
        "typeName": ".trajectorycontroller.MotionScalingLimits",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "motionScalingLimits",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_motion_scaling_limits", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "MotionScalingLimits",
      "field": [{
        "name": "joint_velocity_max",
        "number": 1,
        "label": 3,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "jointVelocityMax",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "joint_acceleration_max",
        "number": 2,
        "label": 3,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "jointAccelerationMax",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "SpeedJ",
      "field": [{
        "name": "direction",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".trajectorycontroller.JointDirection",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "direction",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "collision_config",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".trajectorycontroller.CollisionConfig",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "collisionConfig",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_collision_config", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "Frame",
      "field": [{
        "name": "parent",
        "number": 1,
        "label": 1,
        "type": 14,
        "typeName": ".trajectorycontroller.BuiltInFrame",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "parent",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "pose_in_parent",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".geometry.Pose",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "poseInParent",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "Orientation",
      "field": [{
        "name": "parent",
        "number": 1,
        "label": 1,
        "type": 14,
        "typeName": ".trajectorycontroller.BuiltInFrame",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "parent",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "rotation_in_parent",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".geometry.Quaternion",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "rotationInParent",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "SpeedL",
      "field": [{
        "name": "direction",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".trajectorycontroller.CartesianDirection",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "direction",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "reference",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".trajectorycontroller.Frame",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "reference",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "commanded_frame",
        "number": 3,
        "label": 1,
        "type": 11,
        "typeName": ".trajectorycontroller.Frame",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "commandedFrame",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "velocity_expressed_in",
        "number": 4,
        "label": 1,
        "type": 11,
        "typeName": ".trajectorycontroller.Orientation",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "velocityExpressedIn",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "collision_config",
        "number": 5,
        "label": 1,
        "type": 11,
        "typeName": ".trajectorycontroller.CollisionConfig",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "collisionConfig",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_collision_config", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ExecuteTrajectory",
      "field": [{
        "name": "trajectory",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".joints.JointTrajectory",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "trajectory",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "WorldToBaseUpdate",
      "field": [{
        "name": "world_to_base",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".geometry.Pose",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "worldToBase",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "JointDirection",
      "field": [{
        "name": "entries",
        "number": 1,
        "label": 3,
        "type": 17,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "entries",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "CartesianDirection",
      "field": [{
        "name": "linear",
        "number": 1,
        "label": 3,
        "type": 17,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "linear",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "angular",
        "number": 2,
        "label": 3,
        "type": 17,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "angular",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "Primitive",
      "field": [{
        "name": "servo_j",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".trajectorycontroller.ServoJ",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "servoJ",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "servo_l",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".trajectorycontroller.ServoL",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "servoL",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "speed_j",
        "number": 3,
        "label": 1,
        "type": 11,
        "typeName": ".trajectorycontroller.SpeedJ",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "speedJ",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "speed_l",
        "number": 4,
        "label": 1,
        "type": 11,
        "typeName": ".trajectorycontroller.SpeedL",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "speedL",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "execute_trajectory",
        "number": 5,
        "label": 1,
        "type": 11,
        "typeName": ".trajectorycontroller.ExecuteTrajectory",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "executeTrajectory",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "world_to_base_update",
        "number": 6,
        "label": 1,
        "type": 11,
        "typeName": ".trajectorycontroller.WorldToBaseUpdate",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "worldToBaseUpdate",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "primitive", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "GetJogDirectionsRequest",
      "field": [{
        "name": "reference",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".trajectorycontroller.Frame",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "reference",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "commanded_frame",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".trajectorycontroller.Frame",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "commandedFrame",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "velocity_expressed_in",
        "number": 3,
        "label": 1,
        "type": 11,
        "typeName": ".trajectorycontroller.Orientation",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "velocityExpressedIn",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "JogDirectionResult",
      "field": [{
        "name": "direction",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".trajectorycontroller.CartesianDirection",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "direction",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "feasible",
        "number": 2,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "feasible",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "error",
        "number": 3,
        "label": 1,
        "type": 14,
        "typeName": ".trajectorycontroller.TCErrorCode",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "error",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_error", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "GetJogDirectionsReply",
      "field": [{
        "name": "results",
        "number": 1,
        "label": 3,
        "type": 11,
        "typeName": ".trajectorycontroller.JogDirectionResult",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "results",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "error",
        "number": 2,
        "label": 1,
        "type": 14,
        "typeName": ".trajectorycontroller.TCErrorCode",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "error",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_error", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "EnqueueReply",
      "field": [{
        "name": "accepted",
        "number": 1,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "accepted",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "primitive_id",
        "number": 2,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "primitiveId",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "error",
        "number": 3,
        "label": 1,
        "type": 14,
        "typeName": ".trajectorycontroller.TCErrorCode",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 1,
        "jsonName": "error",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_primitive_id", "options": undefined }, { "name": "_error", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "SafetyLimits",
      "field": [{
        "name": "joint_velocity_max",
        "number": 1,
        "label": 3,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "jointVelocityMax",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "joint_acceleration_max",
        "number": 2,
        "label": 3,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "jointAccelerationMax",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "joint_torque_max",
        "number": 3,
        "label": 3,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "jointTorqueMax",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "tcp_linear_velocity_max",
        "number": 4,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "tcpLinearVelocityMax",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "SafetySession",
      "field": [{
        "name": "full_speed",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".trajectorycontroller.SafetyLimits",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "fullSpeed",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "slow_speed",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".trajectorycontroller.SafetyLimits",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "slowSpeed",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "SpeedSlider",
      "field": [{
        "name": "value",
        "number": 1,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "value",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "SetReply",
      "field": [{
        "name": "accepted",
        "number": 1,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "accepted",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "error",
        "number": 2,
        "label": 1,
        "type": 14,
        "typeName": ".trajectorycontroller.TCErrorCode",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "error",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_error", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ControllerStateMsg",
      "field": [{
        "name": "state",
        "number": 1,
        "label": 1,
        "type": 14,
        "typeName": ".trajectorycontroller.TCState",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "state",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "active_primitive_id",
        "number": 2,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "activePrimitiveId",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "active_primitive_type",
        "number": 3,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 1,
        "jsonName": "activePrimitiveType",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "queue_depth",
        "number": 4,
        "label": 1,
        "type": 13,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "queueDepth",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "speed_scaling",
        "number": 5,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "speedScaling",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "paused",
        "number": 6,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "paused",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "step_count",
        "number": 7,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "stepCount",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "errors",
        "number": 8,
        "label": 3,
        "type": 14,
        "typeName": ".trajectorycontroller.TCErrorCode",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "errors",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "collision_status",
        "number": 9,
        "label": 1,
        "type": 11,
        "typeName": ".trajectorycontroller.CollisionStatus",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 2,
        "jsonName": "collisionStatus",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_active_primitive_id", "options": undefined }, {
        "name": "_active_primitive_type",
        "options": undefined,
      }, { "name": "_collision_status", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "PrimitiveEventMsg",
      "field": [{
        "name": "type",
        "number": 1,
        "label": 1,
        "type": 14,
        "typeName": ".trajectorycontroller.PrimitiveEventType",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "type",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "primitive_id",
        "number": 2,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "primitiveId",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "error",
        "number": 3,
        "label": 1,
        "type": 14,
        "typeName": ".trajectorycontroller.TCErrorCode",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 1,
        "jsonName": "error",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_primitive_id", "options": undefined }, { "name": "_error", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "CommandedStateMsg",
      "field": [{
        "name": "tick",
        "number": 1,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "tick",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "timestamp",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".google.protobuf.Timestamp",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "timestamp",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "positions",
        "number": 3,
        "label": 3,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "positions",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "velocities",
        "number": 4,
        "label": 3,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "velocities",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "accelerations",
        "number": 5,
        "label": 3,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "accelerations",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "suppressed",
        "number": 6,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "suppressed",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "overrun",
        "number": 7,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "overrun",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "target_fresh",
        "number": 9,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 1,
        "jsonName": "targetFresh",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "target_write_seq",
        "number": 12,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 2,
        "jsonName": "targetWriteSeq",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "servoj_target",
        "number": 10,
        "label": 1,
        "type": 11,
        "typeName": ".trajectorycontroller.ServoJTarget",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "servojTarget",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "servol_target",
        "number": 11,
        "label": 1,
        "type": 11,
        "typeName": ".trajectorycontroller.ServoLTarget",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "servolTarget",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "streamed_target", "options": undefined }, {
        "name": "_target_fresh",
        "options": undefined,
      }, { "name": "_target_write_seq", "options": undefined }],
      "options": undefined,
      "reservedRange": [{ "start": 8, "end": 9 }],
      "reservedName": [],
    }, {
      "name": "ServoJTarget",
      "field": [{
        "name": "target_joints",
        "number": 1,
        "label": 3,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "targetJoints",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "target_joint_velocities",
        "number": 2,
        "label": 3,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "targetJointVelocities",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ServoLTarget",
      "field": [{
        "name": "pose_stream",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".geometry.Pose",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "poseStream",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "twist_stream",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".trajectorycontroller.CartesianVelocity",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "twistStream",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "TCEventMsg",
      "field": [{
        "name": "code",
        "number": 1,
        "label": 1,
        "type": 14,
        "typeName": ".trajectorycontroller.TCEventCode",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "code",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "severity",
        "number": 2,
        "label": 1,
        "type": 14,
        "typeName": ".trajectorycontroller.TCSeverity",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "severity",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "message",
        "number": 3,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "message",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "int_a",
        "number": 4,
        "label": 1,
        "type": 13,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "intA",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "int_b",
        "number": 5,
        "label": 1,
        "type": 13,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "intB",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "int_c",
        "number": 6,
        "label": 1,
        "type": 13,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "intC",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "float_a",
        "number": 7,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "floatA",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "seq",
        "number": 8,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "seq",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "dropped_events",
        "number": 9,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "droppedEvents",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "occurred_at_us",
        "number": 10,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "occurredAtUs",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "producer_epoch",
        "number": 11,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "producerEpoch",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "CollisionConfig",
      "field": [{
        "name": "collision_margin",
        "number": 1,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "collisionMargin",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "penetration_bypass",
        "number": 2,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "penetrationBypass",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "disabled_pairs",
        "number": 3,
        "label": 3,
        "type": 11,
        "typeName": ".trajectorycontroller.DisabledCollisionPair",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "disabledPairs",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "DisabledCollisionPair",
      "field": [{
        "name": "link_a",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "linkA",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "link_b",
        "number": 2,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "linkB",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "CollisionBody",
      "field": [{
        "name": "label",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "label",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "mount",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".trajectorycontroller.MountOffset",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "mount",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_mount", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "MountOffset",
      "field": [{
        "name": "tx",
        "number": 1,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "tx",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "ty",
        "number": 2,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "ty",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "tz",
        "number": 3,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "tz",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "rx",
        "number": 4,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "rx",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "ry",
        "number": 5,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "ry",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "rz",
        "number": 6,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "rz",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "rw",
        "number": 7,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "rw",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "CollisionEquipment",
      "field": [{
        "name": "bodies",
        "number": 1,
        "label": 3,
        "type": 11,
        "typeName": ".trajectorycontroller.CollisionBody",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "bodies",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "CollisionStatus",
      "field": [{
        "name": "min_distance",
        "number": 1,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "minDistance",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "closest_link_a",
        "number": 2,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "closestLinkA",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "closest_link_b",
        "number": 3,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "closestLinkB",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "collision_binding",
        "number": 4,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "collisionBinding",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "r_collision",
        "number": 5,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "rCollision",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "zone",
        "number": 6,
        "label": 1,
        "type": 14,
        "typeName": ".trajectorycontroller.CollisionZone",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "zone",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }],
    "enumType": [{
      "name": "TCState",
      "value": [
        { "name": "TC_IDLE", "number": 0, "options": undefined },
        { "name": "TC_EXECUTING", "number": 1, "options": undefined },
        { "name": "TC_STOPPING", "number": 2, "options": undefined },
        { "name": "TC_ERROR", "number": 3, "options": undefined },
      ],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "TCErrorCode",
      "value": [
        { "name": "TC_ERROR_NONE", "number": 0, "options": undefined },
        { "name": "TC_ERROR_IN_SINGULARITY", "number": 1, "options": undefined },
        { "name": "TC_ERROR_TRAJECTORY_OVER_LIMITS", "number": 2, "options": undefined },
        { "name": "TC_ERROR_JOINT_COMMAND_OUT_OF_LIMITS", "number": 3, "options": undefined },
        { "name": "TC_ERROR_STALENESS_TIMEOUT", "number": 4, "options": undefined },
        { "name": "TC_ERROR_INVALID_TRAJECTORY", "number": 5, "options": undefined },
        { "name": "TC_ERROR_COMPUTATION", "number": 6, "options": undefined },
        { "name": "TC_ERROR_WORKSPACE_LIMIT_VIOLATION", "number": 7, "options": undefined },
        { "name": "TC_ERROR_OVERRUN", "number": 8, "options": undefined },
        { "name": "TC_ERROR_QUEUE_FULL", "number": 9, "options": undefined },
        { "name": "TC_ERROR_NO_CONTROL", "number": 10, "options": undefined },
        { "name": "TC_ERROR_NOT_READY", "number": 11, "options": undefined },
        { "name": "TC_ERROR_NOT_IDLE", "number": 12, "options": undefined },
        { "name": "TC_ERROR_INVALID_ARGUMENT", "number": 13, "options": undefined },
        { "name": "TC_ERROR_FRAME_NOT_SPECIFIED", "number": 14, "options": undefined },
        { "name": "TC_ERROR_FRAME_NOT_SUPPORTED", "number": 15, "options": undefined },
        { "name": "TC_ERROR_INCOMPATIBLE_FRAMES", "number": 16, "options": undefined },
        { "name": "TC_ERROR_MALFORMED_TARGET", "number": 17, "options": undefined },
        { "name": "TC_ERROR_STREAM_JUMP", "number": 18, "options": undefined },
        { "name": "TC_ERROR_TRACKER_ERROR_EXCEEDED", "number": 19, "options": undefined },
        { "name": "TC_ERROR_SELF_COLLISION", "number": 20, "options": undefined },
        { "name": "TC_ERROR_INVALID_COLLISION_CONFIG", "number": 21, "options": undefined },
      ],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "PrimitiveEventType",
      "value": [
        { "name": "PRIMITIVE_EVENT_UNSPECIFIED", "number": 0, "options": undefined },
        { "name": "PRIMITIVE_STARTED", "number": 1, "options": undefined },
        { "name": "PRIMITIVE_COMPLETE", "number": 2, "options": undefined },
        { "name": "PRIMITIVE_STOPPED", "number": 3, "options": undefined },
        { "name": "PRIMITIVE_FAILED", "number": 4, "options": undefined },
        { "name": "PRIMITIVE_QUEUE_CLEARED", "number": 5, "options": undefined },
      ],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "BuiltInFrame",
      "value": [
        { "name": "BUILT_IN_FRAME_UNSPECIFIED", "number": 0, "options": undefined },
        { "name": "BUILT_IN_FRAME_WORLD", "number": 1, "options": undefined },
        { "name": "BUILT_IN_FRAME_BASE", "number": 2, "options": undefined },
        { "name": "BUILT_IN_FRAME_FLANGE", "number": 3, "options": undefined },
        { "name": "BUILT_IN_FRAME_CAMERA", "number": 4, "options": undefined },
      ],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "TCSeverity",
      "value": [{ "name": "TC_SEVERITY_UNSPECIFIED", "number": 0, "options": undefined }, {
        "name": "TC_SEVERITY_INFO",
        "number": 1,
        "options": undefined,
      }, { "name": "TC_SEVERITY_WARN", "number": 2, "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "TCEventCode",
      "value": [
        { "name": "TC_EVENT_CODE_UNSPECIFIED", "number": 0, "options": undefined },
        { "name": "TC_EVENT_CODE_INVALID_VELOCITY_CONSTRAINT", "number": 1, "options": undefined },
        { "name": "TC_EVENT_CODE_MALFORMED_CONSTRAINT_LIST", "number": 2, "options": undefined },
        { "name": "TC_EVENT_CODE_INVALID_NOMINAL", "number": 3, "options": undefined },
        { "name": "TC_EVENT_CODE_BINDING_CONSTRAINT_CHANGED", "number": 4, "options": undefined },
        { "name": "TC_EVENT_CODE_DIVIDE_BY_ZERO", "number": 5, "options": undefined },
        { "name": "TC_EVENT_CODE_NON_FINITE_INPUT", "number": 6, "options": undefined },
        { "name": "TC_EVENT_CODE_NON_FINITE_OUTPUT", "number": 7, "options": undefined },
        { "name": "TC_EVENT_CODE_COMMAND_TIMEOUT", "number": 8, "options": undefined },
        { "name": "TC_EVENT_CODE_NON_POSITIVE_LIMIT", "number": 9, "options": undefined },
        { "name": "TC_EVENT_CODE_DECEL_HORIZON_OVERFLOW", "number": 10, "options": undefined },
        { "name": "TC_EVENT_CODE_IK_SINGULAR", "number": 11, "options": undefined },
        { "name": "TC_EVENT_CODE_IK_NO_SOLUTION", "number": 12, "options": undefined },
        { "name": "TC_EVENT_CODE_IK_WARNING", "number": 13, "options": undefined },
        { "name": "TC_EVENT_CODE_NON_UNIT_QUATERNION", "number": 14, "options": undefined },
        { "name": "TC_EVENT_CODE_INVALID_FILTER_GAIN", "number": 15, "options": undefined },
        { "name": "TC_EVENT_CODE_ACCEL_LIMIT_EXCEEDED", "number": 16, "options": undefined },
        { "name": "TC_EVENT_CODE_FK_FAILED", "number": 17, "options": undefined },
        { "name": "TC_EVENT_CODE_JACOBIAN_INVALID", "number": 18, "options": undefined },
        { "name": "TC_EVENT_CODE_JACOBIAN_SINGULAR", "number": 19, "options": undefined },
        { "name": "TC_EVENT_CODE_POSE_JUMP_EXCEEDED", "number": 20, "options": undefined },
        { "name": "TC_EVENT_CODE_TRACKER_ERROR_EXCEEDED", "number": 21, "options": undefined },
        { "name": "TC_EVENT_CODE_TRACKER_GAIN_EXCEEDS_ACCEL", "number": 22, "options": undefined },
      ],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "CollisionZone",
      "value": [
        { "name": "COLLISION_ZONE_UNKNOWN", "number": 0, "options": undefined },
        { "name": "COLLISION_ZONE_SAFE", "number": 1, "options": undefined },
        { "name": "COLLISION_ZONE_MARGIN", "number": 2, "options": undefined },
        { "name": "COLLISION_ZONE_PENETRATION", "number": 3, "options": undefined },
      ],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }],
    "service": [{
      "name": "TrajectoryControllerService",
      "method": [{
        "name": "Enqueue",
        "inputType": ".trajectorycontroller.Primitive",
        "outputType": ".trajectorycontroller.EnqueueReply",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "GetJogDirections",
        "inputType": ".trajectorycontroller.GetJogDirectionsRequest",
        "outputType": ".trajectorycontroller.GetJogDirectionsReply",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "SetSafetySession",
        "inputType": ".trajectorycontroller.SafetySession",
        "outputType": ".trajectorycontroller.SetReply",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "SetSpeedSlider",
        "inputType": ".trajectorycontroller.SpeedSlider",
        "outputType": ".trajectorycontroller.SetReply",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "Pause",
        "inputType": ".google.protobuf.Empty",
        "outputType": ".trajectorycontroller.ControllerStateMsg",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "Resume",
        "inputType": ".google.protobuf.Empty",
        "outputType": ".trajectorycontroller.ControllerStateMsg",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "ClearQueue",
        "inputType": ".google.protobuf.Empty",
        "outputType": ".trajectorycontroller.ControllerStateMsg",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "Stop",
        "inputType": ".google.protobuf.Empty",
        "outputType": ".trajectorycontroller.ControllerStateMsg",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "FastStop",
        "inputType": ".google.protobuf.Empty",
        "outputType": ".trajectorycontroller.ControllerStateMsg",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "ClearError",
        "inputType": ".google.protobuf.Empty",
        "outputType": ".trajectorycontroller.ControllerStateMsg",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }],
      "options": undefined,
    }, {
      "name": "TrajectoryControllerTopics",
      "method": [{
        "name": "ControllerState",
        "inputType": ".trajectorycontroller.ControllerStateMsg",
        "outputType": ".google.protobuf.Empty",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "PrimitiveEvent",
        "inputType": ".trajectorycontroller.PrimitiveEventMsg",
        "outputType": ".google.protobuf.Empty",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "CommandedState",
        "inputType": ".trajectorycontroller.CommandedStateMsg",
        "outputType": ".google.protobuf.Empty",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "TCEvent",
        "inputType": ".trajectorycontroller.TCEventMsg",
        "outputType": ".google.protobuf.Empty",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }],
      "options": undefined,
    }, {
      "name": "TrajectoryControllerSinks",
      "method": [{
        "name": "WriteServoJ",
        "inputType": ".trajectorycontroller.ServoJTarget",
        "outputType": ".google.protobuf.Empty",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "WriteServoL",
        "inputType": ".trajectorycontroller.ServoLTarget",
        "outputType": ".google.protobuf.Empty",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }],
      "options": undefined,
    }],
    "extension": [],
    "options": {
      "javaPackage": "",
      "javaOuterClassname": "",
      "javaMultipleFiles": false,
      "javaGenerateEqualsAndHash": false,
      "javaStringCheckUtf8": false,
      "optimizeFor": 1,
      "goPackage": "sb.app/messenger/proto/trajectorycontroller",
      "ccGenericServices": false,
      "javaGenericServices": false,
      "pyGenericServices": false,
      "phpGenericServices": false,
      "deprecated": false,
      "ccEnableArenas": true,
      "objcClassPrefix": "",
      "csharpNamespace": "",
      "swiftPrefix": "",
      "phpClassPrefix": "",
      "phpNamespace": "",
      "phpMetadataNamespace": "",
      "rubyPackage": "",
      "uninterpretedOption": [],
    },
    "sourceCodeInfo": {
      "location": [{
        "path": [5, 1, 2, 12],
        "span": [31, 2, 25],
        "leadingComments": "",
        "trailingComments": " setter rejected because TC not IDLE\n",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 1, 2, 13],
        "span": [32, 2, 33],
        "leadingComments": "",
        "trailingComments": " out-of-range / wrong length / NaN\n",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 1, 2, 14],
        "span": [34, 2, 36],
        "leadingComments": " SpeedL frame-slot validation (commanded_frame / reference / velocity_expressed_in).\n",
        "trailingComments": " a required frame/orientation slot was left unset\n",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 1, 2, 15],
        "span": [37, 2, 36],
        "leadingComments": " Parent frame not supported (e.g. CAMERA commanded_frame, FLANGE velocity\n axes).\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 1, 2, 16],
        "span": [39, 2, 36],
        "leadingComments": " Reference and commanded_frame on the same side (not actuatable).\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 1, 2, 17],
        "span": [42, 2, 33],
        "leadingComments":
          " Streamed target structurally malformed (missing field, wrong arity); ends\n the streaming session.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 1, 2, 18],
        "span": [43, 2, 28],
        "leadingComments": "",
        "trailingComments": " ServoL: consecutive streamed poses too far apart\n",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 1, 2, 19],
        "span": [44, 2, 39],
        "leadingComments": "",
        "trailingComments": " ServoL: target too far from the tracked pose\n",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 1, 2, 20],
        "span": [45, 2, 31],
        "leadingComments": "",
        "trailingComments": " self-collision detected\n",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 1, 2, 21],
        "span": [46, 2, 41],
        "leadingComments": "",
        "trailingComments": " invalid collision configuration\n",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 2, 2, 1],
        "span": [51, 2, 24],
        "leadingComments": "",
        "trailingComments": " Primitive began executing.\n",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 2, 2, 2],
        "span": [52, 2, 25],
        "leadingComments": "",
        "trailingComments": " Primitive finished naturally (isComplete() returned true).\n",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 2, 2, 3],
        "span": [53, 2, 24],
        "leadingComments": "",
        "trailingComments": " Primitive was interrupted by Stop/FastStop before completing.\n",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 2, 2, 4],
        "span": [54, 2, 23],
        "leadingComments": "",
        "trailingComments": " Primitive encountered an error (see error field).\n",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 2, 2, 5],
        "span": [55, 2, 30],
        "leadingComments": "",
        "trailingComments": " ClearQueue was called; pending primitives were discarded.\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 0],
        "span": [73, 0, 76, 1],
        "leadingComments":
          " Linear and angular velocity of a frame.\n Linear: meters/second.  Angular: radians/second.\n\n This message does not say which frame the velocity is in. The message that\n carries a CartesianVelocity says that.\n",
        "trailingComments": "",
        "leadingDetachedComments": [" --- Messages ---\n"],
      }, {
        "path": [4, 1],
        "span": [82, 0, 94, 1],
        "leadingComments":
          " Starts a position-streaming joint jog. Carries the stream settings and no\n joint target: targets are supplied exclusively through\n WriteServoJ(ServoJTarget), and the arm holds its commanded position until\n the first one arrives.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 1, 2, 0],
        "span": [83, 2, 17],
        "leadingComments": "",
        "trailingComments": " First-order LPF gain on the streamed target.\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 1, 2, 1],
        "span": [84, 2, 32],
        "leadingComments": "",
        "trailingComments": " Staleness window before the stream is considered stale.\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 1, 2, 2],
        "span": [85, 2, 33],
        "leadingComments": "",
        "trailingComments": " Smooth-start ramp from commanded position to the stream.\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 1, 2, 3],
        "span": [93, 2, 49],
        "leadingComments":
          " Position smoothing time constant, ms. When a streamed target differs from\n the dead-reckoned prediction from the last position and velocity, the\n difference decays exponentially with this time constant instead of being\n applied in one control cycle, so stream cadence jitter becomes a small\n position adjustment rather than a one-cycle velocity spike. 0 (and the\n proto3 default when absent) = same-cycle reset. The TC rejects values\n above 1000 ms at enqueue.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 2],
        "span": [112, 0, 120, 1],
        "leadingComments":
          " Starts a pose-streaming session. Carries the stream settings and no\n pose target: targets are supplied exclusively through\n WriteServoL(ServoLTarget), and the arm holds its commanded pose until the\n first one arrives.\n\n All three frame slots are REQUIRED (unset → TC_ERROR_FRAME_NOT_SPECIFIED),\n per-command and snapshotted at enqueue, with the same validation and error\n codes as SpeedL:\n   * reference:             frame the streamed pose is expressed in; parent must\n                            be world-side (WORLD/BASE). Same side as\n                            commanded_frame → TC_ERROR_INCOMPATIBLE_FRAMES.\n   * commanded_frame:       the controlled point (flange→TCP offset) driven to the\n                            streamed pose. parent must be FLANGE; CAMERA →\n                            TC_ERROR_FRAME_NOT_SUPPORTED.\n   * velocity_expressed_in: rotation-only frame selecting the axes the streamed\n                            twist is resolved along.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 2, 2, 0],
        "span": [113, 2, 17],
        "leadingComments": "",
        "trailingComments": " First-order LPF gain on the streamed target.\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 2, 2, 1],
        "span": [114, 2, 32],
        "leadingComments": "",
        "trailingComments": " Staleness window before the stream is considered stale.\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 2, 2, 2],
        "span": [115, 2, 33],
        "leadingComments": "",
        "trailingComments": " Smooth-start ramp from commanded pose to the stream.\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 2, 2, 6],
        "span": [119, 2, 57],
        "leadingComments": "",
        "trailingComments": " Absent: no per-joint limits.\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 3, 2, 0],
        "span": [123, 2, 41],
        "leadingComments": "",
        "trailingComments": " rad/s, length 6\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 3, 2, 1],
        "span": [124, 2, 45],
        "leadingComments": "",
        "trailingComments": " rad/s², length 6\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 4],
        "span": [131, 0, 134, 1],
        "leadingComments":
          " Direction-only joint jog — speed at TC comes from snapshotted\n JogConfig × slider × active SafetyLimits, composed at enqueue time.\n Requires SetSafetySession and SetSpeedSlider to have been pushed at\n least once before this primitive will be accepted.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 5],
        "span": [141, 0, 145, 1],
        "leadingComments":
          " A built-in reference frame plus a rigid offset expressed in that frame.\n The frame in world coordinates is world_to_parent · pose_in_parent.\n\n The offset is REQUIRED: an unset slot (default zero quaternion) is rejected\n with TC_ERROR_FRAME_NOT_SPECIFIED, never treated as identity.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 5, 2, 1],
        "span": [143, 2, 144, 8],
        "leadingComments": "",
        "trailingComments": " rigid offset (position + orientation) of this frame, in `parent` coordinates\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 6],
        "span": [151, 0, 154, 1],
        "leadingComments":
          " A built-in reference frame plus a rotation-only offset expressed in that\n frame. It selects the axes a direction or streamed twist is resolved\n along, so only orientation is meaningful (no translation). Same\n required / fail-loud contract as Frame.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 6, 2, 1],
        "span": [153, 2, 45],
        "leadingComments": "",
        "trailingComments": " rotation of this frame relative to `parent`\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 7],
        "span": [170, 0, 176, 1],
        "leadingComments":
          " Cartesian jog. `direction` is a one-hot ±1 axis; the TC sets the\n linear/angular speed from snapshotted JogConfig × slider × SafetyLimits.\n Same SetSafetySession + SetSpeedSlider prerequisites as SpeedJ.\n\n All three frame slots are REQUIRED (unset → TC_ERROR_FRAME_NOT_SPECIFIED),\n per-command and snapshotted at enqueue:\n   * reference:             frame the motion is actuated relative to; parent must\n                            be world-side (WORLD/BASE). Same side as commanded_frame\n                            → TC_ERROR_INCOMPATIBLE_FRAMES.\n   * commanded_frame:       the controlled point (flange→TCP offset) — origin of the\n                            rotational-jog pivot and where the TCP-linear limit binds.\n                            parent must be FLANGE; CAMERA → TC_ERROR_FRAME_NOT_SUPPORTED.\n   * velocity_expressed_in: rotation-only frame selecting the axes `direction` is\n                            applied along (WORLD/BASE, identity rotation).\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 10, 2, 0],
        "span": [191, 2, 30],
        "leadingComments": "",
        "trailingComments": " length 6\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 11, 2, 0],
        "span": [195, 2, 29],
        "leadingComments": "",
        "trailingComments": " length 3\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 11, 2, 1],
        "span": [196, 2, 30],
        "leadingComments": "",
        "trailingComments": " length 3\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 12, 2, 5],
        "span": [206, 4, 207, 10],
        "leadingComments": "",
        "trailingComments": " sequenced settings command, not a motion primitive\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 13],
        "span": [213, 0, 217, 1],
        "leadingComments":
          " Request information of which cardinal directions in the given frame\n are feasible jog directions. Passed data matches subset of SpeedL request.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 14],
        "span": [220, 0, 224, 1],
        "leadingComments": " Part of response to GetJogDirectionsRequest\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 15],
        "span": [227, 0, 230, 1],
        "leadingComments": " Response to GetJogDirectionsRequest\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 17, 2, 0],
        "span": [239, 2, 41],
        "leadingComments": "",
        "trailingComments": " rad/s, length 6\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 17, 2, 1],
        "span": [240, 2, 45],
        "leadingComments": "",
        "trailingComments": " rad/s², length 6\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 17, 2, 2],
        "span": [241, 2, 39],
        "leadingComments": "",
        "trailingComments": " Nm, length 6\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 17, 2, 3],
        "span": [242, 2, 37],
        "leadingComments": "",
        "trailingComments": " m/s\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 19, 2, 0],
        "span": [251, 2, 19],
        "leadingComments": "",
        "trailingComments": " [0, 1]\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 23],
        "span": [282, 0, 335, 1],
        "leadingComments":
          " One control cycle's commanded joint state as the controller produced it,\n before arm-control-bot's 200 Hz hardware loop resamples it onto CAN.\n Diagnostic only, behind the \"onlinePlannerCommandLogging\" flag. One message\n per cycle, suppressed ones included, so a gap in `tick` means messages were\n lost in transit rather than never sent.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 23, 2, 0],
        "span": [285, 2, 18],
        "leadingComments":
          " Cycles since the controller was constructed. Contiguous; does not reset\n when recording starts.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 23, 2, 1],
        "span": [290, 2, 42],
        "leadingComments":
          " Stamped on the control thread at the cycle itself, CLOCK_REALTIME, same\n epoch as the rest of the blackbox. Prefer it over MCAP log time, which is\n quantized to the publisher's drain period.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 23, 2, 2],
        "span": [292, 2, 32],
        "leadingComments": "",
        "trailingComments": " radians\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 23, 2, 3],
        "span": [293, 2, 33],
        "leadingComments": "",
        "trailingComments": " radians/second\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 23, 2, 4],
        "span": [294, 2, 36],
        "leadingComments": "",
        "trailingComments": " radians/second^2\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 23, 2, 5],
        "span": [298, 2, 22],
        "leadingComments":
          " Not authorized to command this cycle (another control source, or the arm\n braked / in antigravity / failed). Nothing was sent to hardware.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 23, 2, 6],
        "span": [303, 2, 19],
        "leadingComments":
          " The previous cycle overran the control period. Not by itself a skipped\n cycle — one that runs long and catches up sets this too. Real skips never\n take a tick number; they show as a jump in `timestamp`.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 23, 9],
        "span": [312, 2, 13],
        "leadingComments":
          " Tag 8 held a cycles_since_write counter, never shipped outside this stack.\n Derivable by counting ticks since the last target_fresh, and it froze\n outside STREAMING. Reserved, not reused, so old recordings cannot be\n misread against this schema.\n",
        "trailingComments": "",
        "leadingDetachedComments": [
          " --- Streaming input. The two fields below are present on every cycle a\n ServoJ / ServoL stream ran; all three are absent otherwise. ---\n",
        ],
      }, {
        "path": [4, 23, 2, 7],
        "span": [316, 2, 33],
        "leadingComments":
          " A setpoint the primitive had not seen before arrived this cycle. Arrival,\n not consumption — see the oneof below.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 23, 2, 8],
        "span": [323, 2, 40],
        "leadingComments":
          " The inbound mailbox's write counter for the sampled value. A step above one\n means setpoints landed between cycles and latest-wins overwrote them\n unread, which nothing else here can show. Compare its total against the\n sink/WriteServo* count. writeError() shares the counter, so a step can also\n be a target rejected as malformed.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 23, 8, 0],
        "span": [331, 2, 334, 3],
        "leadingComments":
          " The consumed target, verbatim, in the frame it crossed the mailbox in — for\n ServoL the enqueue's reference frame, not the world-resolved pose. Same\n message types as the sink/ recordings, so the two diff field by field.\n\n Set only when this cycle's command was produced from it: unset before the\n first setpoint and during a stop, where the decel block drives the output.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 24],
        "span": [342, 0, 345, 1],
        "leadingComments":
          " A streamed ServoJ setpoint. Both fields are required and are consumed as a\n pair: the velocity advances the position target between commands\n (first-order hold). You can get zero-order hold behavior by setting velocity\n to zero. A target carrying only positions is dropped rather\n than assumed to mean zero velocity.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 24, 2, 0],
        "span": [343, 2, 36],
        "leadingComments": "",
        "trailingComments": " Joint positions in radians.\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 24, 2, 1],
        "span": [344, 2, 46],
        "leadingComments": "",
        "trailingComments": " Joint velocities in radians/second.\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 25],
        "span": [356, 0, 359, 1],
        "leadingComments":
          " A streamed ServoL setpoint. Both fields are required and are consumed as a\n pair: the twist advances the pose target between commands (first-order\n hold). You can get zero-order hold behavior by setting the twist to zero. A\n target carrying only a pose is dropped rather than assumed to mean zero\n twist.\n\n The frames come from the ServoL that started the stream: the pose is the\n target pose of `commanded_frame` expressed in `reference`, and the twist is\n the velocity of that same point expressed in `velocity_expressed_in`.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 25, 2, 0],
        "span": [357, 2, 32],
        "leadingComments": "",
        "trailingComments": " position in meters, orientation as a unit quaternion\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 25, 2, 1],
        "span": [358, 2, 37],
        "leadingComments": "",
        "trailingComments": " linear in m/s, angular in rad/s\n",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 4],
        "span": [369, 0, 373, 1],
        "leadingComments":
          " Severity of a TC notification.\n\n There is deliberately no ERROR value. Errors never traverse this path:\n enterError() pushes the structured error straight into the debug event\n mailbox, and Notification's constructor asserts the severity is not ERROR.\n Offering an ERROR value here would invite a second, competing error channel.\n",
        "trailingComments": "",
        "leadingDetachedComments": [" --- TC notification events (INFO/WARN) ---\n"],
      }, {
        "path": [5, 5],
        "span": [382, 0, 406, 1],
        "leadingComments":
          " Mirrors bots::trajectory_controller::EventCode, one enumerator per condition\n class (cpp/apps/arm-control-bot/src/trajectory_controller/events/Event.h).\n\n Append-only, never renumbered: this is a customer-facing vocabulary once it\n leaves the robot. The C++ enum pins explicit values for the same reason, and\n the C++ -> proto mapping is an exhaustive switch rather than a cast, so\n reordering either side cannot silently rewrite a code's meaning.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 26],
        "span": [417, 0, 443, 1],
        "leadingComments":
          " One TC notification, off the RT thread and onto the network.\n\n The payload slots carry the code-specific values the message template\n substitutes: they are the flat TCEvent's int_A/int_B/int_C/float_A (a\n condition needing more than three ints and one scalar gets a second code,\n not a wider message — hence no float_b).\n\n Internal-only fields stay off the wire on purpose: producer_id and the\n factory call site (file/line) are developer diagnostics, not external API.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 26, 2, 2],
        "span": [422, 2, 21],
        "leadingComments":
          " Rendered from the code's message template with the payload substituted.\n Rendered on the publisher thread — never on the 1 kHz control loop.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 26, 2, 7],
        "span": [429, 2, 17],
        "leadingComments":
          " Monotonic per producer process, stamped by the publisher. Lets a consumer\n detect loss between itself and the robot.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 26, 2, 8],
        "span": [432, 2, 28],
        "leadingComments":
          " Events rejected at push since the producer started, because the event ring\n was full. Ring-level and unattributed: there is no per-code breakdown.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 26, 2, 9],
        "span": [437, 2, 29],
        "leadingComments":
          " CLOCK_MONOTONIC microseconds, stamped when the event was *raised* on the\n control loop — not when it was drained. A drain-time stamp would be up to\n one drain period late and identical across a batch, making 300 events in\n 300 ms indistinguishable from a full second of the condition.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 26, 2, 10],
        "span": [442, 2, 29],
        "leadingComments":
          ' Boot id, constant for the producer process. Without it an arm-control-bot\n restart resets seq and dropped_events while a consumer\'s per-code\n aggregation state persists, splicing two producer lifetimes into one total\n and turning a mid-condition restart into a false "resolved".\n',
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 27],
        "span": [450, 0, 455, 1],
        "leadingComments":
          " Per-primitive collision configuration.\n Sent inside SpeedJ/SpeedL at Enqueue time.\n No collision_config = collision disabled (margin defaults to 0).\n",
        "trailingComments": "",
        "leadingDetachedComments": [" --- Collision ---\n"],
      }, {
        "path": [4, 27, 2, 0],
        "span": [451, 2, 30],
        "leadingComments": "",
        "trailingComments": " meters; 0 = disabled\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 27, 2, 1],
        "span": [452, 2, 30],
        "leadingComments": "",
        "trailingComments": " allow jog out of already-colliding state\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 27, 2, 2],
        "span": [453, 2, 52],
        "leadingComments": "",
        "trailingComments": " per-primitive ACM overrides\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 28, 2, 0],
        "span": [458, 2, 20],
        "leadingComments": "",
        "trailingComments": ' URDF link name: "upper_arm_link"\n',
        "leadingDetachedComments": [],
      }, {
        "path": [4, 28, 2, 1],
        "span": [459, 2, 20],
        "leadingComments": "",
        "trailingComments": ' URDF link name: "forearm_link"\n',
        "leadingDetachedComments": [],
      }, {
        "path": [4, 29, 2, 0],
        "span": [463, 2, 19],
        "leadingComments": "",
        "trailingComments": ' manifest key: "onrobot_rg2", "dqc_connector"\n',
        "leadingDetachedComments": [],
      }, {
        "path": [4, 29, 2, 1],
        "span": [464, 2, 33],
        "leadingComments": "",
        "trailingComments": " offset from flange; omit = directly on flange\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 30, 2, 0],
        "span": [468, 2, 16],
        "leadingComments": "",
        "trailingComments": " translation x (meters)\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 30, 2, 1],
        "span": [469, 2, 16],
        "leadingComments": "",
        "trailingComments": " translation y (meters)\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 30, 2, 2],
        "span": [470, 2, 16],
        "leadingComments": "",
        "trailingComments": " translation z (meters)\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 30, 2, 3],
        "span": [471, 2, 16],
        "leadingComments": "",
        "trailingComments": " rotation quaternion x\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 30, 2, 4],
        "span": [472, 2, 16],
        "leadingComments": "",
        "trailingComments": " rotation quaternion y\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 30, 2, 5],
        "span": [473, 2, 16],
        "leadingComments": "",
        "trailingComments": " rotation quaternion z\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 30, 2, 6],
        "span": [474, 2, 16],
        "leadingComments": "",
        "trailingComments": " rotation quaternion w\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 31],
        "span": [480, 0, 482, 1],
        "leadingComments":
          " Equipment config — session-level (like SafetySession).\n Botman calls SetCollisionEquipment once when gripper changes.\n TC snapshots at Enqueue.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 6],
        "span": [485, 0, 490, 1],
        "leadingComments": " Collision telemetry in ControllerStateMsg.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 6, 2, 1],
        "span": [487, 2, 26],
        "leadingComments": "",
        "trailingComments": " min_distance >= margin\n",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 6, 2, 2],
        "span": [488, 2, 28],
        "leadingComments": "",
        "trailingComments": " 0 <= min_distance < margin\n",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 6, 2, 3],
        "span": [489, 2, 33],
        "leadingComments": "",
        "trailingComments": " min_distance < 0\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 32, 2, 0],
        "span": [493, 2, 26],
        "leadingComments": "",
        "trailingComments": " meters, inf if no checker\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 32, 2, 1],
        "span": [494, 2, 27],
        "leadingComments": "",
        "trailingComments": " link index (-1 if N/A)\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 32, 2, 2],
        "span": [495, 2, 27],
        "leadingComments": "",
        "trailingComments": " link index (-1 if N/A)\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 32, 2, 3],
        "span": [496, 2, 29],
        "leadingComments": "",
        "trailingComments": " true if COLLISION is binding constraint\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 32, 2, 4],
        "span": [497, 2, 25],
        "leadingComments": "",
        "trailingComments": " restrictiveness value (0 = not active)\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 32, 2, 5],
        "span": [498, 2, 25],
        "leadingComments": "",
        "trailingComments": " explicit zone classification\n",
        "leadingDetachedComments": [],
      }, {
        "path": [6, 0],
        "span": [504, 0, 515, 1],
        "leadingComments": " @language: cpp\n",
        "trailingComments": "",
        "leadingDetachedComments": [" --- Services ---\n"],
      }, {
        "path": [6, 1],
        "span": [518, 0, 523, 1],
        "leadingComments": " @language: cpp\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [6, 2],
        "span": [526, 0, 529, 1],
        "leadingComments": " @language: cpp\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }],
    },
    "syntax": "proto3",
  },
  references: {
    ".trajectorycontroller.TCState": TCState,
    ".trajectorycontroller.TCErrorCode": TCErrorCode,
    ".trajectorycontroller.PrimitiveEventType": PrimitiveEventType,
    ".trajectorycontroller.BuiltInFrame": BuiltInFrame,
    ".trajectorycontroller.TCSeverity": TCSeverity,
    ".trajectorycontroller.TCEventCode": TCEventCode,
    ".trajectorycontroller.CollisionZone": CollisionZone,
    ".trajectorycontroller.CartesianVelocity": CartesianVelocity,
    ".trajectorycontroller.ServoJ": ServoJ,
    ".trajectorycontroller.ServoL": ServoL,
    ".trajectorycontroller.MotionScalingLimits": MotionScalingLimits,
    ".trajectorycontroller.SpeedJ": SpeedJ,
    ".trajectorycontroller.Frame": Frame,
    ".trajectorycontroller.Orientation": Orientation,
    ".trajectorycontroller.SpeedL": SpeedL,
    ".trajectorycontroller.ExecuteTrajectory": ExecuteTrajectory,
    ".trajectorycontroller.WorldToBaseUpdate": WorldToBaseUpdate,
    ".trajectorycontroller.JointDirection": JointDirection,
    ".trajectorycontroller.CartesianDirection": CartesianDirection,
    ".trajectorycontroller.Primitive": Primitive,
    ".trajectorycontroller.GetJogDirectionsRequest": GetJogDirectionsRequest,
    ".trajectorycontroller.JogDirectionResult": JogDirectionResult,
    ".trajectorycontroller.GetJogDirectionsReply": GetJogDirectionsReply,
    ".trajectorycontroller.EnqueueReply": EnqueueReply,
    ".trajectorycontroller.SafetyLimits": SafetyLimits,
    ".trajectorycontroller.SafetySession": SafetySession,
    ".trajectorycontroller.SpeedSlider": SpeedSlider,
    ".trajectorycontroller.SetReply": SetReply,
    ".trajectorycontroller.ControllerStateMsg": ControllerStateMsg,
    ".trajectorycontroller.PrimitiveEventMsg": PrimitiveEventMsg,
    ".trajectorycontroller.CommandedStateMsg": CommandedStateMsg,
    ".trajectorycontroller.ServoJTarget": ServoJTarget,
    ".trajectorycontroller.ServoLTarget": ServoLTarget,
    ".trajectorycontroller.TCEventMsg": TCEventMsg,
    ".trajectorycontroller.CollisionConfig": CollisionConfig,
    ".trajectorycontroller.DisabledCollisionPair": DisabledCollisionPair,
    ".trajectorycontroller.CollisionBody": CollisionBody,
    ".trajectorycontroller.MountOffset": MountOffset,
    ".trajectorycontroller.CollisionEquipment": CollisionEquipment,
    ".trajectorycontroller.CollisionStatus": CollisionStatus,
    ".trajectorycontroller.TrajectoryControllerService": TrajectoryControllerServiceClientImpl,
    ".trajectorycontroller.TrajectoryControllerTopics": TrajectoryControllerTopicsClientImpl,
    ".trajectorycontroller.TrajectoryControllerSinks": TrajectoryControllerSinksClientImpl,
  },
  dependencies: [protoMetadata1, protoMetadata2, protoMetadata3, protoMetadata4],
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
